/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthProtocolsCheckPasswordRequest {
  email: string;
  password: string;
}

export interface AuthProtocolsCheckPasswordResponse {
  success: string;
}

export interface AuthProtocolsGetUserInfoResponse {
  /** @format int32 */
  client_id: number;
  client_name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  created_date: string;
  custom_filter: boolean;
  detected_tip: boolean;
  language: string;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  piracy_info?: AuthProtocolsGetUserInfoResponsePiracyInfo;
  primary_type?: MarqCommonEnumsClientClientTypeEnum;
  reporting_cap_client: boolean;
  role: MarqCommonEnumsClientClientRoleEnum;
  status: MarqCommonEnumsClientStatusEnum;
  transliteration: boolean;
  use_cv_assistant: boolean;
  use_domain_name: boolean;
  use_ecommerce: boolean;
  use_gen_ai: boolean;
  use_impersonation_only: boolean;
  use_map_monitoring: boolean;
  use_social_media: boolean;
  use_stand_alone: boolean;
  user_email: string;
  /** @format int32 */
  user_id: number;
}

export interface AuthProtocolsGetUserInfoResponsePiracyInfo {
  confirm_need: boolean;
  google_confirm_need: boolean;
}

export interface AuthProtocolsLoginRequest {
  email: string;
  password: string;
  remember_me: boolean;
}

export interface AuthProtocolsLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsLoginWithTokenRequest {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsLoginWithTokenResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsLogoutRequest {
  access_token?: string | null;
}

export interface AuthProtocolsLogoutResponse {
  success: string;
}

export interface AuthProtocolsOktaLoginRequest {
  code: string;
  code_verifier: string;
  url: string;
}

export interface AuthProtocolsOktaLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsOktaLoginInfoRequest {
  app_domain: string;
}

export interface AuthProtocolsOktaLoginInfoResponse {
  okta_client_id: string;
  redirect_uri: string;
}

export interface AuthProtocolsOktaRiotLoginRequest {
  access_token: string;
}

export interface AuthProtocolsOktaRiotLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsRefreshTokenRequest {
  refresh_token: string;
}

export interface AuthProtocolsRefreshTokenResponse {
  access_token: string;
}

export interface AuthorizedSellerKeywordFilteringProtocolsAddKeywordsRequest {
  keywords: string[];
}

export interface AuthorizedSellerKeywordFilteringProtocolsAddKeywordsResponse {
  /** @format int32 */
  added_count: number;
}

export interface AuthorizedSellerKeywordFilteringProtocolsDeleteKeywordRequest {
  keyword_ids: number[];
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsKeyword {
  added_by: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  added_on: string;
  /** @format int32 */
  id: number;
  is_general_keyword: boolean;
  keyword: string;
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsRequest {
  sorted_column?: MarqCommonEnumsAuthorizedSellerKeywordSortedColumnEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsResponse {
  keywords: AuthorizedSellerKeywordFilteringProtocolsGetKeywordsKeyword[];
}

export interface AuthorizedSellerProtocolsAddAuthorizedSellerRequest {
  add_url_list: string[];
}

export interface AuthorizedSellerProtocolsExportAuthorizedSellerRequest {
  domain_id_list?: number[] | null;
  id_list?: number[] | null;
  search?: string | null;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerProtocolsGetAllAuthorizedSellerIdListRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetAllAuthorizedSellerIdListResponse {
  id_list: number[];
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerCountRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailAuthorizedSellerDetailResponse {
  country: MarqCommonEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  listing_url?: string | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
  shop_name: string;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailRequest {
  /** @format int32 */
  seller_id: number;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailResponse {
  data: AuthorizedSellerProtocolsGetAuthorizedSellerDetailAuthorizedSellerDetailResponse;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListAuthorizedSellerResponse {
  country: MarqCommonEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  listing_url?: string | null;
  new: boolean;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
  shop_name: string;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListRequest {
  domain_id_list?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListResponse {
  seller_list: AuthorizedSellerProtocolsGetAuthorizedSellerListAuthorizedSellerResponse[];
}

export interface AuthorizedSellerProtocolsGetDomainFilterRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetDomainFilterResponse {
  domain_list: MarqBrandCoreModelProtocolCountryDomains[];
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedWebsiteProtocolsAddAuthWebsiteRequest {
  add_url_list: string[];
}

export interface AuthorizedWebsiteProtocolsExportAuthWebsiteRequest {
  id_list?: number[] | null;
  search: string;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedWebsiteProtocolsGetAllAuthWebsiteIdListRequest {
  search?: string | null;
}

export interface AuthorizedWebsiteProtocolsGetAllAuthWebsiteIdListResponse {
  id_list: number[];
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteCountRequest {
  search?: string | null;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search: string;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListResponse {
  list: AuthorizedWebsiteProtocolsGetAuthWebsiteListResponseAuthWebsiteResponse[];
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListResponseAuthWebsiteResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  domain_url: string;
  /** @format int32 */
  id: number;
}

export interface CommonProtocolsGetCreditsResponse {
  /** @format int32 */
  remaining_credits: number;
  /** @format int32 */
  remaining_returned_credits: number;
  /** @format int32 */
  total_credits: number;
}

export interface EmailProtocolsRequestUpdateEmailRequest {
  email: string;
  password: string;
}

export interface EmailProtocolsUpdateEmailAddressRequest {
  token: string;
}

export interface EmployeeSignupProtocolsGetEmployeeDataWithTokenRequest {
  token: string;
}

export interface EmployeeSignupProtocolsGetEmployeeDataWithTokenResponse {
  client_currency: MarqCommonEnumsCurrencyEnum;
  company?: string | null;
  country?: MarqCommonEnumsCountryCodeEnum;
  email?: string | null;
  /** @format int32 */
  id: number;
  language?: string | null;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface EmployeeSignupProtocolsUpdateRegisterRequest {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  password: string;
  token: string;
}

export interface EmployeeSignupProtocolsUpdateRegisterResponse {
  access_token: string;
  refresh_token: string;
}

export interface HomeProtocolsBrand {
  brand_name: string;
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsClosedItem {
  brand_name: string;
  channel: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  detail: string;
  enforcement_type?: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  /** @format int32 */
  id: number;
  is_new: boolean;
  title: string;
  type: MarqCommonEnumsCrClientRequestTypeEnum;
}

export interface HomeProtocolsFileIdNameAndUrl {
  filename: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface HomeProtocolsFilenameAndUrl {
  filename: string;
  url: string;
}

export interface HomeProtocolsGetBrandAssetsResponse {
  list: HomeProtocolsGetBrandAssetsResponseBrandAssets[];
}

export interface HomeProtocolsGetBrandAssetsResponseBrandAssets {
  assets: HomeProtocolsGetBrandAssetsResponseBrandAssetsAsset[];
  /** @format int32 */
  brand_id: number;
  brand_name: string;
}

export interface HomeProtocolsGetBrandAssetsResponseBrandAssetsAsset {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  id: number;
  name: string;
}

export interface HomeProtocolsGetClosedListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  limit?: number | null;
  /** @format int32 */
  offset?: number | null;
  /** @format int32 */
  page?: number | null;
}

export interface HomeProtocolsGetClosedListResponse {
  closed_list: HomeProtocolsClosedItem[];
  /** @format int32 */
  total_closed: number;
}

export interface HomeProtocolsGetHomeResponse {
  name?: string | null;
  /** @format int32 */
  new_closed: number;
  payment_failed_reason?: string | null;
  performance_report?: HomeProtocolsGetHomeResponsePerfReportSection;
  register_card_flag: boolean;
  request_types: MarqCommonEnumsCrClientRequestTypeEnum[];
  to_do_list: HomeProtocolsGetHomeResponseToDoItem[];
}

export interface HomeProtocolsGetHomeResponsePerfReportSection {
  filename: string;
  is_new: boolean;
  s3url: string;
}

export interface HomeProtocolsGetHomeResponseToDoItem {
  detail: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date?: string | null;
  file_type?: MarqCommonEnumsCrClientTaskFileTypeEnum;
  is_new: boolean;
  /** @format int32 */
  task_id: number;
  title: string;
  type: HomeProtocolsToDoType;
  wrong_file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetOpenedListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  limit?: number | null;
  /** @format int32 */
  offset?: number | null;
  /** @format int32 */
  page?: number | null;
}

export interface HomeProtocolsGetOpenedListResponse {
  opened_list: HomeProtocolsOpenedItem[];
  /** @format int32 */
  total_opened: number;
}

export interface HomeProtocolsGetOtherDetailDocument {
  /** @format int32 */
  doc_id: number;
  filename: string;
}

export interface HomeProtocolsGetOtherDetailRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsGetOtherDetailResponse {
  brand_name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  email?: string | null;
  /** @format int32 */
  id: number;
  reply?: HomeProtocolsGetOtherDetailResponseReply;
  request: HomeProtocolsGetOtherDetailResponseReq;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
}

export interface HomeProtocolsGetOtherDetailResponseReply {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  detail: string;
  document_list: HomeProtocolsGetOtherDetailDocument[];
  title: string;
}

export interface HomeProtocolsGetOtherDetailResponseReq {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  detail: string;
  document_list: HomeProtocolsGetOtherDetailDocument[];
  title: string;
}

export interface HomeProtocolsGetOtherPresignedDownloadUrlRequest {
  /** @format int32 */
  doc_id: number;
}

export interface HomeProtocolsGetOtherPresignedDownloadUrlResponse {
  url: string;
}

export interface HomeProtocolsGetOtherPresignedUploadUrlRequest {
  filename: string;
}

export interface HomeProtocolsGetOtherPresignedUploadUrlResponse {
  url: string;
}

export interface HomeProtocolsGetTaskDetailRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsGetTaskDetailResponse {
  /** @format int32 */
  id: number;
  list: HomeProtocolsGetTaskDetailResponseTypeAndDetail[];
  task_status: MarqCommonEnumsCrClientTaskStatusEnum;
}

export type HomeProtocolsGetTaskDetailResponseDetail =
  | HomeProtocolsGetTaskDetailResponseOpenDetail
  | HomeProtocolsGetTaskDetailResponseReOpenDetail
  | HomeProtocolsGetTaskDetailResponseReplyDetail;

export interface HomeProtocolsGetTaskDetailResponseOpenDetail {
  attached_template_list: HomeProtocolsFileIdNameAndUrl[];
  brand?: HomeProtocolsBrand;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date: string;
  file_type: MarqCommonEnumsCrClientTaskFileTypeEnum;
  required_task: boolean;
  requirement: string;
  task_subtitle: string;
  task_title: string;
}

export interface HomeProtocolsGetTaskDetailResponseReOpenDetail {
  attached_template_list: HomeProtocolsFileIdNameAndUrl[];
  brand?: HomeProtocolsBrand;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date: string;
  file_type: MarqCommonEnumsCrClientTaskFileTypeEnum;
  required_task: boolean;
  requirement: string;
  task_subtitle: string;
  task_title: string;
  wrong_file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetTaskDetailResponseReplyDetail {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetTaskDetailResponseTypeAndDetail {
  detail: HomeProtocolsGetTaskDetailResponseDetail;
  type: MarqCommonEnumsCrClientTaskMessageTypeEnum;
}

export interface HomeProtocolsOpenedItem {
  brand_name: string;
  channel: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  detail: string;
  enforcement_type?: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  /** @format int32 */
  id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  title: string;
  type: MarqCommonEnumsCrClientRequestTypeEnum;
}

export interface HomeProtocolsPostOtherAddRequest {
  /** @format int32 */
  brand_id?: number | null;
  detail: string;
  document_list?: HomeProtocolsPostOtherAddRequestDocument[] | null;
  title: string;
}

export interface HomeProtocolsPostOtherAddRequestDocument {
  filename: string;
  url: string;
}

export interface HomeProtocolsPostOtherAddResponse {
  /** @format int32 */
  cr_id: number;
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsPostUrlAddRequest {
  /** @format int32 */
  brand_id: number;
  channel_type: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  enforcement_type: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  url_list: string[];
}

export interface HomeProtocolsPostUrlAddResponse {
  /** @format int32 */
  cr_id: number;
  /** @format int32 */
  id: number;
  /** @format int32 */
  total: number;
}

export interface HomeProtocolsPostUrlGetEcommerceDetailRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsPostUrlGetEcommerceDetailResponse {
  brand_name: string;
  channel_type: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  /** @format int32 */
  completed: number;
  email?: string | null;
  enforcement_type: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  /** @format int32 */
  failed: number;
  /** @format int32 */
  id: number;
  /** @format int32 */
  in_progress: number;
  list: MarqBrandModelResponseCrUrlResponseInterfaceCommerceItem[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  /** @format int32 */
  total: number;
}

export interface HomeProtocolsPostUrlGetWebsiteDetailRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsPostUrlGetWebsiteDetailResponse {
  brand_name: string;
  channel_type: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  /** @format int32 */
  completed: number;
  email?: string | null;
  enforcement_type: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  /** @format int32 */
  failed: number;
  /** @format int32 */
  id: number;
  /** @format int32 */
  in_progress: number;
  list: MarqBrandModelResponseCrUrlResponseInterfaceWebsiteItem[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  /** @format int32 */
  total: number;
}

export interface HomeProtocolsTaskDismissRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsTaskGetDownloadUrlRequest {
  /** @format int32 */
  file_id: number;
  /** @format int32 */
  task_id: number;
}

export interface HomeProtocolsTaskGetDownloadUrlResponse {
  url: string;
}

export interface HomeProtocolsTaskGetUploadUrlRequest {
  filename: string;
}

export interface HomeProtocolsTaskGetUploadUrlResponse {
  url: string;
}

export interface HomeProtocolsTaskSubmitRequest {
  /** @format int32 */
  id: number;
  list: HomeProtocolsFilenameAndUrl[];
}

export enum HomeProtocolsToDoType {
  Confirm = 'confirm',
  ReviewMarketplaceSeller = 'review_marketplace_seller',
  ReviewSocialMediaSeller = 'review_social_media_seller',
  Upload = 'upload',
  ReUpload = 're_upload',
}

export interface InfringingImageProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface InfringingImageProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface InfringingImageProtocolsCreateInfringingImageLibraryByPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  image_file_url_list?: string[] | null;
}

export interface InfringingImageProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface InfringingImageProtocolsGetAllCollectionsRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface InfringingImageProtocolsGetAllCollectionsResponse {
  brand_collection: InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioCollection[];
}

export interface InfringingImageProtocolsGetAllCollectionsResponseCollectionData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioCollection {
  brand: InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioData;
  collection_tree: InfringingImageProtocolsGetAllCollectionsResponseCollectionData[];
}

export interface InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface InfringingImageProtocolsGetAllInfringingImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponse {
  brands: InfringingImageProtocolsGetAllInfringingImagesResponseBrandImage[];
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponseBrandImage {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  collections: InfringingImageProtocolsGetAllInfringingImagesResponseBrandImageImageByCollection[];
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponseBrandImageImageByCollection {
  /** @format int32 */
  collection_id?: number | null;
  collection_name?: string | null;
  images: MarqBrandCoreModelResponseIdWithUrl[];
}

export interface InfringingImageProtocolsGetCollectionDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface InfringingImageProtocolsGetCollectionDetailResponse {
  collection_data: InfringingImageProtocolsGetCollectionDetailResponseCollectionData;
}

export interface InfringingImageProtocolsGetCollectionDetailResponseCollectionData {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id?: number | null;
  infringing_images: InfringingImageProtocolsGetCollectionDetailResponseInfringingImage[];
  name: string;
}

export interface InfringingImageProtocolsGetCollectionDetailResponseInfringingImage {
  /** @format int32 */
  id: number;
  url?: string | null;
}

export interface InfringingImageProtocolsGetImageCountByBrandResponse {
  brands: InfringingImageProtocolsGetImageCountByBrandResponseBrand[];
}

export interface InfringingImageProtocolsGetImageCountByBrandResponseBrand {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  count: number;
}

export interface InfringingImageProtocolsGetInfringingImagePresignedUrlRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  file_name: string;
}

export interface InfringingImageProtocolsGetInfringingImagePresignedUrlResponse {
  url: string;
}

export interface InfringingImageProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
}

export interface InfringingImageProtocolsUpdateInfringingImageLibraryByPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  delete_file_id_list?: number[] | null;
  image_file_url_list: string[];
}

export interface LSettingsProtocolsDeleteEmployeeRequest {
  /** @format int32 */
  employee_id: number;
}

export interface LSettingsProtocolsRequestInvitationEmailRequest {
  email: string;
}

export interface LSettingsProtocolsSendInvitationRequest {
  invitation_data: LSettingsProtocolsSendInvitationRequestInvitation[];
}

export interface LSettingsProtocolsSendInvitationRequestInvitation {
  email: string;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface LSettingsProtocolsUpdateCompanyProfileRequest {
  company_address?: string | null;
  company_name?: string | null;
  country?: MarqCommonEnumsCountryCodeEnum;
  website?: string | null;
}

export interface LSettingsProtocolsUpdateEmployeeRoleRequest {
  /** @format int32 */
  id: number;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface OfficialImageProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface OfficialImageProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface OfficialImageProtocolsCreateOfficialImagesPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  image_file_url_list: OfficialImageProtocolsCreateOfficialImagesPresignedRequestImageFileUrlRequest[];
  note?: string | null;
  product_url?: string | null;
}

export interface OfficialImageProtocolsCreateOfficialImagesPresignedRequestImageFileUrlRequest {
  file_name: string;
  presigned_url: string;
}

export interface OfficialImageProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface OfficialImageProtocolsDeleteOfficialImageRequest {
  /** @format int32 */
  official_image_id: number;
}

export interface OfficialImageProtocolsGetAllCollectionsRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface OfficialImageProtocolsGetAllCollectionsResponse {
  brand_collection: OfficialImageProtocolsGetAllCollectionsResponseIpPortfolioCollection[];
}

export interface OfficialImageProtocolsGetAllCollectionsResponseCollectionData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface OfficialImageProtocolsGetAllCollectionsResponseIpPortfolioCollection {
  brand: OfficialImageProtocolsGetAllCollectionsResponseIpPortfolioData;
  collection_tree: OfficialImageProtocolsGetAllCollectionsResponseCollectionData[];
}

export interface OfficialImageProtocolsGetAllCollectionsResponseIpPortfolioData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface OfficialImageProtocolsGetAllOfficialImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
  collection_filter?: number[] | null;
  search?: string | null;
  sorted_by?: MarqCommonEnumsOiCollectionSortedByEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface OfficialImageProtocolsGetAllOfficialImagesResponse {
  brand_data: OfficialImageProtocolsGetAllOfficialImagesResponseIpPortfolioData[];
}

export interface OfficialImageProtocolsGetAllOfficialImagesResponseCollectionData {
  /** @format int32 */
  count: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /** @format int32 */
  id: number;
  name: string;
  official_image_data: OfficialImageProtocolsGetAllOfficialImagesResponseOfficialImageData[];
}

export interface OfficialImageProtocolsGetAllOfficialImagesResponseIpPortfolioData {
  /** @format int32 */
  collection_count: number;
  collection_data: OfficialImageProtocolsGetAllOfficialImagesResponseCollectionData[];
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
}

export interface OfficialImageProtocolsGetAllOfficialImagesResponseOfficialImageData {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  added_date: string;
  /** @format int32 */
  id: number;
  marq_official_url?: string | null;
  name: string;
  note?: string | null;
  product_url: string;
  s3url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface OfficialImageProtocolsGetCollectionDetailsRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_by?: MarqCommonEnumsOfficialImageSortedByEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface OfficialImageProtocolsGetCollectionDetailsResponse {
  collection_data: OfficialImageProtocolsGetCollectionDetailsResponseCollectionData;
}

export interface OfficialImageProtocolsGetCollectionDetailsResponseCollectionData {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
  official_image_data: OfficialImageProtocolsGetCollectionDetailsResponseOfficialImageData[];
}

export interface OfficialImageProtocolsGetCollectionDetailsResponseOfficialImageData {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  added_date: string;
  /** @format int32 */
  id: number;
  marq_official_url?: string | null;
  name: string;
  note?: string | null;
  product_url: string;
  s3url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface OfficialImageProtocolsGetOfficialImagePresignedUrlRequest {
  file_name: string;
}

export interface OfficialImageProtocolsGetOfficialImagePresignedUrlResponse {
  url: string;
}

export interface OfficialImageProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
}

export interface OfficialImageProtocolsUpdateOfficialImageRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  /** @format int32 */
  id: number;
  name: string;
  note?: string | null;
  product_url?: string | null;
}

export interface OfficialImageWebProtocolsGetClientHomeResponse {
  brands: OfficialImageWebProtocolsGetClientHomeResponseBrand[];
  client_name: string;
}

export interface OfficialImageWebProtocolsGetClientHomeResponseBrand {
  copyright_footer?: string | null;
  logo_url?: string | null;
  official_images: OfficialImageWebProtocolsGetClientHomeResponseOfficialImage[];
}

export interface OfficialImageWebProtocolsGetClientHomeResponseOfficialImage {
  detail_url: string;
  image_url: string;
}

export interface OfficialImageWebProtocolsGetOfficialImageResponse {
  client_name: string;
  copyright_footer?: string | null;
  logo_url?: string | null;
  note?: string | null;
  oi_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  published_date: string;
}

export interface PasswordProtocolsChangePasswordRequest {
  password: string;
}

export interface PasswordProtocolsFindPasswordRequest {
  email: string;
}

export interface PasswordProtocolsResetPasswordRequest {
  password: string;
  token: string;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsCountriesRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsCountriesSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsCountriesResponse {
  country_list: MarqBrandDataModelSellerCountryWithCountDataListCountryWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsMarketplacesRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsDomainsSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsMarketplacesResponse {
  marketplace_list: MarqBrandDataModelSellerMarketplaceWithCountDataListMarketplaceWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsSellersSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersResponse {
  seller_list: MarqBrandDataModelSellerSellerWithCountDataListSellerWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersDataRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  master_id: number;
  /** @format int32 */
  offset: number;
  sort_by?: MarqCommonEnumsSellerintelSellerClusterDataSortByEnum;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersDataResponse {
  seller_data_list: MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSummaryRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  status?: MarqCommonEnumsSellerintelSellerClusterStatusEnum;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSummaryResponse {
  action: MarqBrandDataModelSellerClusterDetailsSummaryAction;
  clustering: MarqBrandDataModelSellerClusterDetailsSummaryClustering;
  most_used_info?: MarqBrandDataModelSellerClusterDetailsSummaryMostUsedInfo;
  processing: MarqBrandDataModelSellerClusterDetailsSummaryProcessing;
}

export interface SellerIntelligenceProtocolsGetClusterMasterStatusResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_updated: string;
  /** @format int32 */
  master_id: number;
  status: MarqCommonEnumsSellerintelSellerClusterStatusEnum;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeARequest {
  mapping_level: MarqCommonEnumsSellerintelSellerIntelMappingLevel;
  /** @format int32 */
  offset?: number | null;
  sort_by: MarqCommonEnumsSellerintelSellerIntelClusterSortBy;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeAResponse {
  cluster_list: MarqBrandDataModelSellerClusterSideInfo[];
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeBRequest {
  /** @format int32 */
  offset?: number | null;
  product_desc: boolean;
  product_title: boolean;
  sort_by: MarqCommonEnumsSellerintelSellerIntelClusterSortBy;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeBResponse {
  cluster_list: MarqBrandDataModelSellerClusterSideInfo[];
}

export interface SellerIntelligenceProtocolsGetExportDataRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
}

export interface SellerIntelligenceProtocolsGetTypeAClusterByIdRequest {
  /** @format int32 */
  cluster_id: number;
  mapping_level: MarqCommonEnumsSellerintelSellerIntelMappingLevel;
}

export interface SellerIntelligenceProtocolsGetTypeAClusterByIdResponse {
  cluster: MarqBrandDataModelSellerCluster;
}

export interface SellerIntelligenceProtocolsGetTypeBClusterByIdRequest {
  /** @format int32 */
  cluster_id: number;
  product_desc: boolean;
  product_title: boolean;
}

export interface SellerIntelligenceProtocolsGetTypeBClusterByIdResponse {
  cluster: MarqBrandDataModelSellerCluster;
}

export interface SettingsProtocolsGetClientActiveCountriesResponse {
  countries: SettingsProtocolsLimitedAccessPolicyCountry[];
}

export interface SettingsProtocolsGetEmployeeListResponse {
  employee_list: SettingsProtocolsGetEmployeeListResponseEmployee[];
}

export interface SettingsProtocolsGetEmployeeListResponseEmployee {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  email?: string | null;
  first_name?: string | null;
  has_signed_up: boolean;
  /** @format int32 */
  id: number;
  last_name?: string | null;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  /** @format int32 */
  order: number;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface SettingsProtocolsGetProfileResponse {
  client_currency: MarqCommonEnumsCurrencyEnum;
  company_address?: string | null;
  company_name?: string | null;
  country?: MarqCommonEnumsCountryCodeEnum;
  email: string;
  first_name?: string | null;
  /** @format int32 */
  id: number;
  last_name?: string | null;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  use_official_image_hosting: boolean;
  website?: string | null;
}

export interface SettingsProtocolsLimitedAccessPolicy {
  brands?: SettingsProtocolsLimitedAccessPolicyBrand[] | null;
  countries?: SettingsProtocolsLimitedAccessPolicyCountry[] | null;
  has_all_brand_access?: boolean | null;
  has_all_country_access?: boolean | null;
}

export interface SettingsProtocolsLimitedAccessPolicyBrand {
  /** @format int32 */
  id: number;
  name?: string | null;
}

export interface SettingsProtocolsLimitedAccessPolicyCountry {
  code: string;
  name?: string | null;
}

export interface CvassistantCvAssistantProtocolsAuthorizeSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsAuthorizeSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsDismissSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsDismissSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsEngageSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsEngageSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsExcelExportRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface CvassistantCvAssistantProtocolsExcelExportBySellerIdRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsFileInfoListResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantFileInfo[];
}

export interface CvassistantCvAssistantProtocolsGetChatAsExcelRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsGetChatAsSnapshotRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsGetDetectedListingDetailsRequest {
  /** @format int32 */
  cv_assistant_id: number;
  /** @format int32 */
  listing_id: number;
}

export interface CvassistantCvAssistantProtocolsGetDetectedListingDetailsResponse {
  asset_name: string;
  description: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  featured: boolean;
  image_list: MarqBrandDataModelListingImageWithFlagsClient[];
  keyword_list: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
}

export interface CvassistantCvAssistantProtocolsGetFilterInfoResultRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetFilterInfoResultResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantResultFilterItem[];
}

export interface CvassistantCvAssistantProtocolsGetSellerCountRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetSellerCountResponse {
  /** @format int32 */
  count: number;
}

export interface CvassistantCvAssistantProtocolsGetSellerDetailsRequest {
  /** @format int32 */
  cv_assistant_id: number;
}

export interface CvassistantCvAssistantProtocolsGetSellerDetailsResponse {
  cv_result?: MarqBrandCoreModelCvassistantCvResult;
  detected_listing_list: MarqBrandCoreModelCvassistantCvAssistantDetectedListing[];
  featured_product: MarqBrandCoreModelCvassistantCvAssistantListingDetails;
  seller_details: MarqBrandCoreModelCvassistantCvAssistantSellerDetails;
}

export interface CvassistantCvAssistantProtocolsGetSellerListRequest {
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  logo_detection_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetSellerListResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantSeller[];
}

export interface ExcelExcelProtocolsExportExcelByWebsiteIdsRequest {
  website_id_list?: number[] | null;
}

export interface ExcelExcelProtocolsGetExcelResultRequest {
  /** @format int32 */
  id: number;
}

export interface ExcelExcelProtocolsGetExcelResultResponse {
  completed: boolean;
  /** @format int32 */
  progress: number;
  url?: string | null;
}

export interface IoKtorHttpContentType {
  content_subtype: string;
  content_type: string;
  parameters: IoKtorHttpHeaderValueParam[];
}

export interface IoKtorHttpHeaderValueParam {
  name: string;
  value: string;
}

export type KotlinAny = unknown;

export interface ListingsListingsProtocolsAddAuthorizedRequest {
  seller_id_list: number[];
}

export interface ListingsListingsProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsClientNote {
  doc_list?: ListingsListingsProtocolsClientNoteDocument[] | null;
  note: string;
}

export interface ListingsListingsProtocolsClientNoteDocument {
  filename: string;
  url: string;
}

export interface ListingsListingsProtocolsDeleteAllCustomTagRequest {
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsDoEnforcementRequest {
  listing_id_list: number[];
  note?: ListingsListingsProtocolsClientNote;
}

export interface ListingsListingsProtocolsDoEnforcementResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
  /** @format int32 */
  request_id?: number | null;
  success: boolean;
}

export interface ListingsListingsProtocolsDoEnforcementBySellerRequest {
  cluster_id_list?: number[] | null;
  note?: ListingsListingsProtocolsClientNote;
  string_seller_id_list?: string[] | null;
}

export interface ListingsListingsProtocolsDoEnforcementBySellerResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
  /** @format int32 */
  request_id?: number | null;
  /** @format int32 */
  requested_count: number;
  success: boolean;
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListRequest {
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListResponse {
  snapshot_list: ListingsListingsProtocolsGetAllSnapshotByListingIdListResponseSnapshotResponse[];
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListResponseSnapshotResponse {
  /** @format int32 */
  listing_id: number;
  snapshot_url: string;
}

export interface ListingsListingsProtocolsGetCounterfeitReasonsRequest {
  /** @format int32 */
  listing_id: number;
}

export interface ListingsListingsProtocolsGetCounterfeitReasonsResponse {
  reasons?: MarqBrandModelResponseCounterfeitReasonResponse;
}

export interface ListingsListingsProtocolsGetDetailsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  listing_id: number;
}

export interface ListingsListingsProtocolsGetDetailsResponse {
  action_section_info: ListingsListingsProtocolsGetDetailsResponseActionSectionInfo;
  client_note?: MarqBrandCoreModelListingClientNoteData;
  enforcement_progress?: MarqBrandCoreModelResponseEnforcementProgressResponse;
  investigation_detail?: MarqBrandCoreModelResponseInvestigationDetailResponse;
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  listing_detail: MarqBrandCoreModelResponseListingDetailResponse;
  seller_detail?: MarqBrandCoreModelResponseSellerDetailResponse;
  tp_detail?: MarqBrandCoreModelResponseTpDetailResponseForBrand;
}

export interface ListingsListingsProtocolsGetDetailsResponseActionSectionInfo {
  client_status?: MarqBrandEnumsListingMonitoringStatusEnum;
  detail?: string | null;
  possible_add_authorized: boolean;
  possible_enforcement: boolean;
  title?: string | null;
}

export interface ListingsListingsProtocolsGetNoteUploadUrlRequest {
  filename: string;
}

export interface ListingsListingsProtocolsGetNoteUploadUrlResponse {
  url: string;
}

export interface ListingsListingsProtocolsReadNoteRequest {
  /** @format int32 */
  listing_id: number;
}

export interface ListingsListingsProtocolsReadNoteResponse {
  note?: MarqBrandCoreModelListingClientNoteData;
}

export interface ListingsListingsProtocolsRequestTestPurchaseRequest {
  listing_id_list: number[];
  tp_type: MarqCommonEnumsTpTPTypeEnum;
}

export interface ListingsListingsProtocolsUndoEnforcementRequest {
  /** @format int32 */
  request_id: number;
}

export interface ListingsListingsProtocolsUndoEnforcementResponse {
  success: boolean;
}

export interface ListingsListingsProtocolsUpdateCounterfeitReasonThumbRequest {
  down?: boolean | null;
  /** @format int32 */
  id: number;
  /** @format int32 */
  listing_id: number;
  up?: boolean | null;
}

export interface ListingsListingsProtocolsUpdateToArchivedRequest {
  listing_ids: number[];
}

export interface ListingsListingsProtocolsUpdateToArchivedResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
}

export interface ListingsListingsProtocolsUpdateToDismissRequest {
  listing_ids: number[];
}

export interface ListingsListingsProtocolsUpdateToDismissResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
}

export interface MapMapModelCountryProtocolsExcludeListingOptionRequest {
  /** @format int32 */
  listing_option_id: number;
}

export interface MapMapModelCountryProtocolsGetFilterInfoDomainRequest {
  country: MarqCommonEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
}

export interface MapMapModelCountryProtocolsGetInfoRequest {
  country: MarqCommonEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelCountryProtocolsGetInfoResponse {
  asset_name: string;
  brand_name: string;
  collection_name?: string | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  currency: MarqCommonEnumsCurrencyEnum;
  domain_price_list: MapMapModelCountryProtocolsGetInfoResponseDomainPrice[];
  /** @format double */
  map: number;
  model_image: string;
  model_name: string;
}

export interface MapMapModelCountryProtocolsGetInfoResponseDomainPrice {
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  /** @format double */
  value: number;
}

export interface MapMapModelCountryProtocolsGetPriceHistoryRequest {
  /** @format int32 */
  listing_option_id: number;
}

export interface MapMapModelCountryProtocolsGetPriceHistoryResponse {
  map_currency: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  map_price: number;
  period: MarqCommonModelLocalDateRange;
  price_chart_list: MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice[];
  recent_price: MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice[];
}

export interface MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format double */
  dynamic_price?: number | null;
  /** @format double */
  final_price?: number | null;
  /** @format double */
  price?: number | null;
  /** @format double */
  shipping_fee?: number | null;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisRequest {
  country: MarqCommonEnumsCountryCodeEnum;
  date_range: MarqCommonModelLocalDateRange;
  domain_list?: number[] | null;
  /** @format int32 */
  model_id: number;
  period: MapMapModelCountryProtocolsMapAnalysisPeriodEnum;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponse {
  lowest_dynamic_price: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPrice;
  violation_listings: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListings;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPrice {
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPriceMapPriceChartValue[];
  group_name_list: string[];
  /** @format double */
  map: number;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPriceMapPriceChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  from_date?: string | null;
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPricePriceGroupData[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  to_date?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPricePriceGroupData {
  /** @format double */
  dynamic_price?: number | null;
  group_name: string;
  is_lowest: boolean;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListings {
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsMapListingChartValue[];
  group_name_list: string[];
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsListingGroupData {
  /** @format int32 */
  count?: number | null;
  group_name: string;
  market_group: boolean;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsMapListingChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  from_date?: string | null;
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsListingGroupData[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  to_date?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationListingsRequest {
  authorized_seller?: boolean | null;
  country: MarqCommonEnumsCountryCodeEnum;
  domain_list?: number[] | null;
  /** @format int32 */
  model_id: number;
  sort?: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelCountryProtocolsGetViolationListingsResponse {
  listing_list: MapMapModelCountryProtocolsGetViolationListingsResponseMapListing[];
  /** @format int32 */
  total_count: number;
}

export interface MapMapModelCountryProtocolsGetViolationListingsResponseMapListing {
  authorized_seller: boolean;
  currency: MarqCommonEnumsCurrencyEnum;
  domain_name: string;
  /** @format double */
  dynamic_price: number;
  /** @format double */
  final_price: number;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id: number;
  listing_url: string;
  /** @format double */
  price: number;
  seller_name?: string | null;
  shipping_additional_info?: string | null;
  /** @format double */
  shipping_fee: number;
  shipping_type: MarqCommonEnumsShippingTypeEnum;
  should_highlight: boolean;
  title: string;
}

export enum MapMapModelCountryProtocolsMapAnalysisPeriodEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export interface MapMapModelProtocolsGetModelInfoRequest {
  /** @format int32 */
  model_id: number;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelProtocolsGetModelInfoResponse {
  asset_name: string;
  brand_name: string;
  collection_name?: string | null;
  /** @format int32 */
  country_count: number;
  country_item_list: MapMapModelProtocolsGetModelInfoResponseCountryItem[];
  /** @format int32 */
  domain_count: number;
  model_image: string;
  model_name: string;
}

export interface MapMapModelProtocolsGetModelInfoResponseCountryItem {
  country: MarqCommonEnumsCountryCodeEnum;
  currency: MarqCommonEnumsCurrencyEnum;
  domain_item_list: MapMapModelProtocolsGetModelInfoResponseDomainMapItem[];
  /** @format double */
  map: number;
}

export interface MapMapModelProtocolsGetModelInfoResponseDomainMapItem {
  currency: MarqCommonEnumsCurrencyEnum;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  /** @format double */
  lowest_dynamic_price: number;
  /** @format double */
  lowest_final_price: number;
  /** @format double */
  lowest_price: number;
  /** @format int32 */
  violation_listings: number;
  /** @format int32 */
  violation_sellers: number;
}

export interface MapMapProtocolsExportRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  model_list?: number[] | null;
  search?: string | null;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapProtocolsExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MapMapProtocolsGetFilterInfoCountryRequest {
  /** @format int32 */
  brand_id?: number | null;
  model_list?: number[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetFilterInfoModelRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetMapCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  model_list?: number[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetMapCountResponse {
  /** @format int32 */
  count: number;
}

export interface MapMapProtocolsGetMapListRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /** @format int32 */
  limit: number;
  model_list?: number[] | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapProtocolsGetMapListResponse {
  list: MapMapProtocolsGetMapListResponseMapModel[];
}

export interface MapMapProtocolsGetMapListResponseCountryMapItem {
  country: MarqCommonEnumsCountryCodeEnum;
  currency: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  lowest_dynamic_price: number;
  /** @format double */
  lowest_final_price: number;
  /** @format double */
  lowest_price: number;
  /** @format double */
  map: number;
  /** @format int32 */
  violation_listings: number;
  /** @format int32 */
  violation_sellers: number;
}

export interface MapMapProtocolsGetMapListResponseMapModel {
  asset_name: string;
  item_list: MapMapProtocolsGetMapListResponseCountryMapItem[];
  /** @format int32 */
  model_id: number;
  model_image: string;
  model_name: string;
}

export enum MarqBrandCoreModelClientListingSortedColumnEnum {
  DetectedDate = 'detected_date',
  Price = 'price',
  ImageRelevancy = 'image_relevancy',
  Marketplace = 'marketplace',
  Asset = 'asset',
  Featured = 'featured',
  SalesVolume = 'sales_volume',
  RequestedDate = 'requested_date',
  UpdatedDate = 'updated_date',
  SellerName = 'seller_name',
}

export interface MarqBrandCoreModelCvassistantCvAssistantDetectedListing {
  asset_name: string;
  featured: boolean;
  /** @format int32 */
  listing_id: number;
  thumbnail_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvAssistantFileInfo {
  file_url?: string | null;
  seller_name: string;
}

export interface MarqBrandCoreModelCvassistantCvAssistantListingDetails {
  asset_name: string;
  description: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  featured: boolean;
  image_list: MarqBrandDataModelListingImageWithFlagsClient[];
  keyword_list: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
}

export interface MarqBrandCoreModelCvassistantCvAssistantResultFilterItem {
  code: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  /** @format int32 */
  count: number;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSeller {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  completed_date?: string | null;
  /** @format int32 */
  cv_assistant_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  /** @format int32 */
  detected_listing_count: number;
  domain_name: string;
  featured_product?: MarqBrandCoreModelCvassistantCvAssistantSellerFeaturedProduct;
  /** @format int32 */
  follower_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_message_sent_date?: string | null;
  /** @format int32 */
  post_count?: number | null;
  reportable?: boolean | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  reported_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date?: string | null;
  result?: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  seller_name?: string | null;
  seller_url?: string | null;
  snapshot_url?: string | null;
  status: MarqCommonEnumsCvassistantCvAssistantStatusEnum;
  tm_logo_used: boolean;
  tm_text_used: boolean;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSellerFeaturedProduct {
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  thumbnail_url: string;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSellerDetails {
  bio?: string | null;
  bio_url?: string | null;
  /** @format int32 */
  detected_listing_count?: number | null;
  domain_name: string;
  /** @format int32 */
  follower_count?: number | null;
  /** @format int32 */
  post_count?: number | null;
  repeat_offender: boolean;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvResult {
  reason_list?: MarqBrandCoreModelCvassistantCvResultReasonItem[] | null;
  result: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  snapshot_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvResultReasonItem {
  description: string;
  title: string;
}

export interface MarqBrandCoreModelListingClientNoteData {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  doc_list: MarqBrandCoreModelListingClientNoteDataDocumentData[];
  email?: string | null;
  /** @format int32 */
  listing_id?: number | null;
  note: string;
}

export interface MarqBrandCoreModelListingClientNoteDataDocumentData {
  /** @format int32 */
  doc_id?: number | null;
  filename: string;
  url: string;
}

export interface MarqBrandCoreModelListingTextWithDetection {
  /** @format int32 */
  end_index?: number | null;
  /** @format int32 */
  start_index?: number | null;
  text: string;
}

export interface MarqBrandCoreModelProtocolCountryDomains {
  /** @format int32 */
  count?: number | null;
  country_code?: MarqCommonEnumsCountryCodeEnum;
  country_name: string;
  domain_list: MarqBrandCoreModelProtocolDomain[];
}

export interface MarqBrandCoreModelProtocolDomain {
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
}

export interface MarqBrandCoreModelProtocolInvestigationTags {
  authentic?: boolean | null;
  copyright: boolean;
  design: boolean;
  free_riding: boolean;
  in_progress?: boolean | null;
  irrelevant?: boolean | null;
  logo_name_conceal: boolean;
  material_diff: boolean;
  model_not_exist: boolean;
  no_authorization: boolean;
  no_counterfeit?: boolean | null;
  no_ip_rights?: boolean | null;
  official_image: boolean;
  official_video: boolean;
  origin_diff: boolean;
  other: boolean;
  reported?: boolean | null;
  shape_diff: boolean;
  size_diff: boolean;
  test_purchased?: boolean | null;
  trademark: boolean;
  unavailable?: boolean | null;
  word_obvious: boolean;
}

export interface MarqBrandCoreModelProtocolTags {
  client_requested: boolean;
  infringing_image?: boolean | null;
  low_price?: boolean | null;
  official_image: boolean;
  repeat_offender?: boolean | null;
  text_detection: boolean;
  top_result: boolean;
  trademark: boolean;
}

export interface MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem {
  /** @format int32 */
  max_risk_score?: number | null;
  /** @format int32 */
  min_risk_score?: number | null;
}

export interface MarqBrandCoreModelResponseClusterProfileResponse {
  address?: string | null;
  business_reg_num?: string | null;
  company_name?: string | null;
  /** @format int32 */
  company_name_seller_count?: number | null;
  country_code?: MarqCommonEnumsCountryCodeEnum;
  country_name?: string | null;
  /** @format int32 */
  country_seller_count?: number | null;
  email?: string | null;
  /** @format int32 */
  email_seller_count?: number | null;
  legal_representative?: string | null;
  marketplace_name?: string | null;
  /** @format int32 */
  marketplace_seller_count?: number | null;
  online_marketing_number?: string | null;
  phone?: string | null;
  seller_name?: string | null;
  /** @format int32 */
  seller_name_seller_count?: number | null;
  seller_type: MarqCommonEnumsSellerAnalyticsSellerTypeEnum;
  seller_url?: string | null;
  shop_name?: string | null;
  /** @format int32 */
  shop_name_seller_count?: number | null;
}

export interface MarqBrandCoreModelResponseCodeLabelComboBoxResponse {
  label: string;
  value: string;
}

export interface MarqBrandCoreModelResponseComboBoxIntValueLabelResponse {
  label: string;
  /** @format int32 */
  value: number;
}

export interface MarqBrandCoreModelResponseCustomTagResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface MarqBrandCoreModelResponseDataDrivenInsightResponse {
  action_list: MarqBrandCoreModelResponsePossibleComboBox[];
  infringing_type_list: MarqBrandCoreModelResponsePossibleComboBox[];
  risk_reason_list: MarqBrandCoreModelResponsePossibleComboBox[];
  /** @format int32 */
  risk_score: number;
}

export interface MarqBrandCoreModelResponseEnforcementProgressResponse {
  enforcement_progress_list: MarqBrandCoreModelResponseEnforcementProgressResponseItem[];
}

export interface MarqBrandCoreModelResponseEnforcementProgressResponseItem {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  email?: string | null;
  type: string;
}

export interface MarqBrandCoreModelResponseIdAndStringValueResponse {
  /** @format int32 */
  id: number;
  value: string;
}

export interface MarqBrandCoreModelResponseIdWithUrl {
  /** @format int32 */
  id: number;
  url?: string | null;
}

export interface MarqBrandCoreModelResponseInvestigationDetailResponse {
  counterfeit_proof_list: MarqBrandCoreModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  /** @format int32 */
  enforceability_info_id: number;
  genuine_proof_list: MarqBrandCoreModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  ip_document_response_list: MarqBrandCoreModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  ipr_used_proof_list: MarqBrandCoreModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  /** @format int32 */
  listing_id: number;
  listing_status: MarqCommonEnumsListingStatusEnum;
  listing_url: string;
  non_enforceable_list: MarqCommonEnumsNonEnforcementReasonEnum[];
  /** @format int32 */
  seller_id?: number | null;
  use_counterfeit?: boolean | null;
  use_counterfeit_type?: MarqCommonEnumsIpCounterfeitType;
  use_ip_rights?: boolean | null;
  use_ip_rights_type?: MarqCommonEnumsIpRightType;
}

export interface MarqBrandCoreModelResponseInvestigationDetailResponseImageWithUrlResponse {
  /** @format int32 */
  id: number;
  img_url: string;
  name?: string | null;
}

export interface MarqBrandCoreModelResponseListingDetailResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  asset_name: string;
  brand_name: string;
  converted_currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  custom_tag_list: MarqBrandCoreModelResponseCustomTagResponse[];
  description: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  domain_name: string;
  domain_type: MarqCommonEnumsDomainTypeEnum;
  images: MarqBrandDataModelListingImageWithFlagsClient[];
  keywords: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  listing_currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  listing_price?: number | null;
  listing_status: MarqCommonEnumsListingStatusEnum;
  official_image_name?: string | null;
  /** @format int32 */
  product_id: number;
  /** @format int32 */
  sales_volume?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  snapshot_pdf_url?: string | null;
  snapshot_pdf_url_list?: string[] | null;
  /** @format int32 */
  stock_count?: number | null;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  tags: MarqBrandCoreModelProtocolTags;
  title: MarqBrandCoreModelListingTextWithDetection;
  url: string;
}

export interface MarqBrandCoreModelResponsePossibleComboBox {
  code: string;
  possible: boolean;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponse {
  cluster?: MarqBrandCoreModelResponseSellerAnalyticResponseClusterSimpleResponse;
  seller?: MarqBrandCoreModelResponseSellerAnalyticResponseSellerSimpleResponse;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponseClusterSimpleResponse {
  /** @format int32 */
  active_listings: number;
  /** @format int32 */
  cluster_id: number;
  cluster_name: string;
  /** @format int32 */
  seller_count: number;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponseSellerSimpleResponse {
  /** @format int32 */
  active_listings: number;
  channel_type: MarqCommonEnumsChannelTypeEnum;
  seller_id: string;
  seller_name: string;
}

export interface MarqBrandCoreModelResponseSellerDetailResponse {
  basic_info: MarqBrandCoreModelResponseSellerDetailResponseBasicInfo;
  count_by_listing_status: MarqBrandCoreModelResponseSellerDetailResponseCountByListingStatus;
  first_enforcement_history: MarqBrandCoreModelResponseSellerDetailResponseFirstEnforcementHistory[];
  recent_enforcement_activity: MarqBrandCoreModelResponseSellerDetailResponseRecentEnforcementActivity[];
}

export interface MarqBrandCoreModelResponseSellerDetailResponseBasicInfo {
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  is_brand_specified: boolean;
  is_clustered: boolean;
  is_repeat_offender: boolean;
  seller_id: string;
  seller_name: string;
  seller_url?: string | null;
}

export interface MarqBrandCoreModelResponseSellerDetailResponseCountByListingStatus {
  /** @format int32 */
  active_count: number;
  /** @format int32 */
  detected_count: number;
  /** @format int32 */
  removed_count: number;
}

export interface MarqBrandCoreModelResponseSellerDetailResponseFirstEnforcementHistory {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  event: string;
}

export interface MarqBrandCoreModelResponseSellerDetailResponseRecentEnforcementActivity {
  listing_title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  removed_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  reported_date: string;
  status: string;
}

export interface MarqBrandCoreModelResponseSellerDetailSummaryResponse {
  /** @format int32 */
  asset_count: number;
  /** @format int32 */
  available_stock_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  first_detected_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  /** @format int64 */
  sales_volume_count: number;
}

export interface MarqBrandCoreModelResponseTpDetailResponseForBrand {
  tp_case_info?: MarqBrandCoreModelResponseTpDetailResponseForBrandTpCaseInfoResponse;
  tp_report?: MarqBrandCoreModelResponseTpReportResponse;
}

export interface MarqBrandCoreModelResponseTpDetailResponseForBrandTpCaseInfoResponse {
  case_id: string;
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  listing_url?: string | null;
  payment: MarqBrandCoreModelResponseTpHistoryGroup[];
  progress: MarqBrandCoreModelResponseTpHistoryGroup[];
  requested_by: string;
  service_type: MarqCommonEnumsTpTPTypeEnum;
  /** @format int32 */
  tp_id: number;
}

export interface MarqBrandCoreModelResponseTpHistory {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  failed_reason?: MarqBrandCoreModelResponseTpHistoryTpFailedReason;
  shipping?: MarqBrandCoreModelResponseTpHistoryTpShipping;
  title: string;
  use_block_icon: boolean;
}

export interface MarqBrandCoreModelResponseTpHistoryTpFailedReason {
  reason_detail?: string | null;
  reason_type?: string | null;
}

export interface MarqBrandCoreModelResponseTpHistoryTpShipping {
  order_confirmation_name?: string | null;
  order_confirmation_url?: string | null;
  shipping_company?: string | null;
  tracking_number?: string | null;
}

export interface MarqBrandCoreModelResponseTpHistoryGroup {
  histories: MarqBrandCoreModelResponseTpHistory[];
  title: string;
}

export interface MarqBrandCoreModelResponseTpReportResponse {
  case_id: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  item_received_date?: string | null;
  order_confirmation_name?: string | null;
  order_confirmation_url?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  purchase_date?: string | null;
  return_address?: string | null;
  return_contact?: string | null;
  return_name?: string | null;
  seller_address?: string | null;
  seller_contact?: string | null;
  seller_name?: string | null;
  /** @format int32 */
  tp_id: number;
  tp_image_list: MarqBrandCoreModelResponseTpReportResponseImageWithUrlResponse[];
  /** @format int32 */
  tp_result_id: number;
}

export interface MarqBrandCoreModelResponseTpReportResponseImageWithUrlResponse {
  /** @format int32 */
  id?: number | null;
  image_name?: string | null;
  image_url: string;
  tp_image_type: MarqCommonEnumsTpTPImageTypeEnum;
}

export interface MarqBrandCoreModelRuleSmartRuleForClient {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  client_id: number;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  custom_tag_ids?: number[] | null;
  /** @format int32 */
  id: number;
  status: MarqCommonEnumsRuleSmartRuleStatusEnum;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface MarqBrandDataModelAssetDataFullIpDoc {
  /** @format int32 */
  ip_doc_id: number;
  unique_name: string;
}

export interface MarqBrandDataModelIpDocByClass {
  class_id?: string | null;
  class_label: string;
  ip_docs: MarqBrandDataModelIpDocByClassIpDoc[];
}

export interface MarqBrandDataModelIpDocByClassIpDoc {
  /** @format int32 */
  ip_doc_id: number;
  unique_name: string;
}

export interface MarqBrandDataModelListingAttachmentResponseBase {
  file_name: string;
  /** @format int32 */
  id: number;
  url: string;
}

export interface MarqBrandDataModelListingImageWithFlagsClient {
  /** @format int32 */
  id: number;
  img_url: string;
  infringing_image_flag: boolean;
  logo_detection_data?: MarqBrandDataTableLogodetectionLogoDetectionData;
  official_image_flag: boolean;
}

export interface MarqBrandDataModelSellerCluster {
  c_sum: MarqBrandDataModelSellerClusterCSum;
  /** @format int32 */
  id: number;
  name?: string | null;
  name_trans?: string | null;
  s_detected_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_remove_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_sales_volume_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_stock_count_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
}

export interface MarqBrandDataModelSellerClusterCSum {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  m_count: number;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  s_count: number;
  /** @format int32 */
  s_vol: number;
  /** @format int32 */
  st_count: number;
}

export interface MarqBrandDataModelSellerClusterSSimpleInfo {
  s_id: string;
  s_name: string;
  s_name_trans: string;
  /** @format int32 */
  s_value: number;
}

export interface MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData {
  /** @format int32 */
  active: number;
  address?: string | null;
  address_trans?: string | null;
  bus_reg_num?: string | null;
  comp_name?: string | null;
  comp_name_trans?: string | null;
  /** @format int32 */
  detected: number;
  email?: string | null;
  leg_rep?: string | null;
  leg_rep_trans?: string | null;
  listing_desc?: string | null;
  listing_images?: string[] | null;
  listing_title?: string | null;
  market: string;
  market_country_code: MarqCommonEnumsCountryCodeEnum;
  online_mark_num?: string | null;
  online_mark_num_trans?: string | null;
  phone_num?: string | null;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  sales_volume: number;
  seller_name?: string | null;
  seller_name_trans?: string | null;
  shop_name?: string | null;
  shop_name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryAction {
  /** @format int32 */
  seller_notice_count: number;
  /** @format int32 */
  tp_count: number;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryClustering {
  /** @format int32 */
  country_count: number;
  /** @format int32 */
  marketplace_count: number;
  /** @format int32 */
  seller_count: number;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryMostUsedInfo {
  address?: string | null;
  /** @format int32 */
  address_matched?: number | null;
  address_trans?: string | null;
  bus_reg_num?: string | null;
  /** @format int32 */
  bus_reg_num_matched?: number | null;
  comp_name?: string | null;
  /** @format int32 */
  comp_name_matched?: number | null;
  comp_name_trans?: string | null;
  email?: string | null;
  /** @format int32 */
  email_matched?: number | null;
  leg_rep?: string | null;
  /** @format int32 */
  leg_rep_matched?: number | null;
  leg_rep_trans?: string | null;
  listing_desc?: string | null;
  /** @format int32 */
  listing_desc_matched?: number | null;
  listing_images?: string[] | null;
  /** @format int32 */
  listing_images_matched?: number | null;
  listing_title?: string | null;
  /** @format int32 */
  listing_title_matched?: number | null;
  online_mark_num?: string | null;
  /** @format int32 */
  online_mark_num_matched?: number | null;
  online_mark_num_trans?: string | null;
  phone_num?: string | null;
  /** @format int32 */
  phone_num_matched?: number | null;
  seller_name?: string | null;
  /** @format int32 */
  seller_name_matched?: number | null;
  seller_name_trans?: string | null;
  shop_name?: string | null;
  /** @format int32 */
  shop_name_matched?: number | null;
  shop_name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryProcessing {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  enforcement_req: number;
  /** @format int32 */
  removed: number;
}

export interface MarqBrandDataModelSellerClusterSideInfo {
  c_sum: MarqBrandDataModelSellerClusterSideInfoCSum;
  /** @format int32 */
  id: number;
  name?: string | null;
  name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterSideInfoCSum {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  m_count: number;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  s_count: number;
  /** @format int32 */
  s_vol: number;
  /** @format int32 */
  st_count: number;
}

export interface MarqBrandDataModelSellerCountryWithCountDataListCountryWithCountData {
  /** @format int32 */
  count_data: number;
  country_code: MarqCommonEnumsCountryCodeEnum;
}

export interface MarqBrandDataModelSellerMarketplaceWithCountDataListMarketplaceWithCountData {
  /** @format int32 */
  count_data: number;
  marketplace_name: string;
}

export interface MarqBrandDataModelSellerSellerWithCountDataListSellerWithCountData {
  /** @format int32 */
  count_data: number;
  seller_id: string;
  seller_name: string;
}

export interface MarqBrandDataTableLogodetectionLogoDetectionData {
  /** @format double */
  bb_x1?: number | null;
  /** @format double */
  bb_x2?: number | null;
  /** @format double */
  bb_y1?: number | null;
  /** @format double */
  bb_y2?: number | null;
  /** @format int32 */
  image_height?: number | null;
  /** @format int32 */
  image_width?: number | null;
}

export enum MarqBrandEnumsListingMonitoringStatusEnum {
  Detection = 'detection',
  Processing = 'processing',
  Reporting = 'reporting',
  SoftNotice = 'soft_notice',
  OnHold = 'on_hold',
  Removed = 'removed',
  Denied = 'denied',
  NonEnforceable = 'non_enforceable',
  Dismissed = 'dismissed',
  TpAll = 'tp_all',
  Reviewing = 'reviewing',
  Purchase = 'purchase',
  Completed = 'completed',
  CaseClosed = 'case_closed',
  ReviewNeeded = 'review_needed',
  Archived = 'archived',
}

export enum MarqBrandEnumsWebsiteBrandSortedColumnEnum {
  DetectedDate = 'detected_date',
  RequestDate = 'request_date',
  UpdatedDate = 'updated_date',
  DomainName = 'domain_name',
  Featured = 'featured',
  ProgressDate = 'progress_date',
  RemovedDate = 'removed_date',
}

export enum MarqBrandEnumsWebsiteContentsTpTabEnum {
  Reviewing = 'reviewing',
  Purchase = 'purchase',
  Completed = 'completed',
  CaseClosed = 'case_closed',
}

export enum MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum {
  Featured = 'featured',
  DetectedDate = 'detected_date',
  RequestedDate = 'requested_date',
  CompletedDate = 'completed_date',
  ListingCount = 'listing_count',
  SellerName = 'seller_name',
}

export enum MarqBrandEnumsCvassistantCvAssistantTabEnum {
  Detected = 'detected',
  Requested = 'requested',
  Completed = 'completed',
}

export interface MarqBrandModelResponseCounterfeitReasonResponse {
  list: MarqBrandModelResponseCounterfeitReasonResponseReason[];
}

export interface MarqBrandModelResponseCounterfeitReasonResponseReason {
  body: string;
  down: boolean;
  /** @format int32 */
  id: number;
  title: string;
  up: boolean;
}

export interface MarqBrandModelResponseCrUrlResponseInterfaceCommerceItem {
  description?: string | null;
  enforceability?: MarqCommonEnumsEnforceabilityEnum;
  /** @format int32 */
  listing_id?: number | null;
  listing_status?: MarqCommonEnumsListingStatusEnum;
  progress_status: MarqCommonEnumsCrCrUrlProgressStatusEnum;
  status: MarqCommonEnumsCrCRUrlStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
  url: string;
}

export interface MarqBrandModelResponseCrUrlResponseInterfaceWebsiteItem {
  description?: string | null;
  progress_status: MarqCommonEnumsCrCrUrlProgressStatusEnum;
  status: MarqCommonEnumsCrCRUrlStatusEnum;
  /** @format int32 */
  sw_id?: number | null;
  sw_status?: MarqCommonEnumsSwSWStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
  url: string;
}

export interface MarqBrandModelResponseEnforcementTPListingResponse {
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date?: string | null;
  domain_name?: string | null;
  exist_tp_report: boolean;
  /** @format int32 */
  id: number;
  images: MarqBrandModelResponseEnforcementTPListingResponseImageResponse[];
  list_currency?: MarqCommonEnumsCurrencyEnum;
  listing_url: string;
  name?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  tp_status_label: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponseEnforcementTPListingResponseImageResponse {
  default: string;
  oi_highest_score?: string | null;
}

export interface MarqBrandModelResponseListingsChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  grouped_count_list?: MarqBrandModelResponseListingsChartValueGroupedCount[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format int64 */
  top_search_count?: number | null;
}

export interface MarqBrandModelResponseListingsChartValueGroupedCount {
  /** @format int64 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface MarqBrandModelResponseMonitoringListingResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date?: string | null;
  domain_name?: string | null;
  /** @format int32 */
  id: number;
  images: MarqBrandModelResponseMonitoringListingResponseImageResponse[];
  list_currency?: MarqCommonEnumsCurrencyEnum;
  listing_status: MarqCommonEnumsListingStatusEnum;
  listing_url: string;
  name?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  snapshot_pdf_url?: string | null;
  snapshot_pdf_url_list?: string[] | null;
  tag: MarqBrandCoreModelProtocolInvestigationTags;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponseMonitoringListingResponseImageResponse {
  default: string;
}

export interface MarqBrandModelResponsePotentialAuthorizedListingResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date?: string | null;
  domain_name?: string | null;
  /** @format int32 */
  id: number;
  images: MarqBrandModelResponsePotentialAuthorizedListingResponseImageResponse[];
  list_currency?: MarqCommonEnumsCurrencyEnum;
  listing_url: string;
  name?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  tags: MarqBrandCoreModelProtocolTags;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponsePotentialAuthorizedListingResponseImageResponse {
  default: string;
}

export interface MarqBrandModelResponseSellerCountResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  /** @format int64 */
  id: number;
  name: string;
  repeat_offender: boolean;
  /** @format int32 */
  seller_score?: number | null;
}

export interface MarqBrandModelResponseTopData {
  grouped_list?: MarqBrandModelResponseTopDataGroupedTopData[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format double */
  listing_percent: number;
  name: string;
}

export interface MarqBrandModelResponseTopDataGroupedTopData {
  /** @format int64 */
  count: number;
  /** @format int32 */
  group_id?: number | null;
  group_label: string;
}

export interface MarqBrandModelResponseSellerBrandSellerClusterResponse {
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id: number;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  other_seller_count?: number | null;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseSellerDemandLetterResponse {
  /** @format int32 */
  demand_letter_count: number;
  /** @format int32 */
  removed_listing_count: number;
  /** @format int32 */
  requested_count: number;
  /** @format int32 */
  sent_count: number;
  status_list: MarqCommonEnumsDemandLetterStatusEnum[];
}

export interface MarqBrandModelResponseSellerSellerAnalyticsResponse {
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id?: number | null;
  clustered: boolean;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  seller_id: string;
  seller_url?: string | null;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseSellerSellerAnalyticsSellerInClusterResponse {
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id?: number | null;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  is_clustered: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  other_seller_count?: number | null;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  seller_id?: string | null;
  seller_url?: string | null;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseWebsiteIpResponse {
  asn?: string | null;
  country?: MarqCommonEnumsCountryCodeEnum;
  /** @format int32 */
  id: number;
  ip_address: string;
  isp?: string | null;
}

export interface MarqBrandModelResponseWebsiteLogoDetectionResponse {
  /** @format double */
  bb_x1?: number | null;
  /** @format double */
  bb_x2?: number | null;
  /** @format double */
  bb_y1?: number | null;
  /** @format double */
  bb_y2?: number | null;
  /** @format int32 */
  image_height?: number | null;
  /** @format int32 */
  image_width?: number | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqCommonEnumsCountryCodeEnum;
  email?: string | null;
  name?: string | null;
  organization_id?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqCommonEnumsCountryCodeEnum;
  email_list?: MarqBrandCoreModelResponseIdAndStringValueResponse[] | null;
  name?: string | null;
  organization?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse {
  email?: string | null;
  homepage?: string | null;
  icann_id?: string | null;
  name?: string | null;
  phone_number?: string | null;
  whois_server?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsDetailInfoResponse {
  asset_name?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  hosting_provider?: MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse;
  ip?: MarqBrandModelResponseWebsiteIpResponse;
  logo_detection?: MarqBrandModelResponseWebsiteLogoDetectionResponse;
  proof_url?: string | null;
  registrant?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse;
  search_keyword?: string | null;
  thumbnail_url?: string | null;
  title: string;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsDetailResponse {
  enforcement_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponse;
  tp_info?: MarqBrandCoreModelResponseTpDetailResponseForBrand;
  website_info: MarqBrandModelResponseWebsiteWebsiteContentsDetailInfoResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponse {
  google_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailInfoResponse {
  country: MarqCommonEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  hosting_provider?: MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse;
  ip?: MarqBrandModelResponseWebsiteIpResponse;
  logo_detection: boolean;
  logo_detection_data?: MarqBrandModelResponseWebsiteLogoDetectionResponse;
  mx_record: boolean;
  proof_url?: string | null;
  registrant?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailResponse {
  enforcement_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponse;
  website_info: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailInfoResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponse {
  google_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesListing {
  country?: MarqCommonEnumsCountryCodeEnum;
  description?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  detected_date: string;
  favicon_url?: string | null;
  google_delisting_status?: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
  ip_address?: string | null;
  logo_detection: boolean;
  logo_detection_data?: MarqBrandModelResponseWebsiteLogoDetectionResponse;
  mx_record: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date?: string | null;
  report_status?: MarqCommonEnumsSwWebsiteReportProgressEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date?: string | null;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export enum MarqCommonEnumsAuthorizedSellerKeywordSortedColumnEnum {
  AddedOn = 'added_on',
  Keyword = 'keyword',
}

export enum MarqCommonEnumsAuthorizedSellerSortedColumnEnum {
  SellerName = 'seller_name',
  AddedDate = 'added_date',
}

export enum MarqCommonEnumsChannelTypeEnum {
  Ecommerce = 'ecommerce',
  SocialMedia = 'social_media',
  WebsiteContents = 'website_contents',
  DomainNames = 'domain_names',
}

export enum MarqCommonEnumsClientStatusEnum {
  Demo = 'demo',
  Deactivated = 'deactivated',
  Test = 'test',
  ActiveClient = 'active_client',
}

export enum MarqCommonEnumsCountryCodeEnum {
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GB = 'GB',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MV = 'MV',
  MY = 'MY',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SX = 'SX',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TL = 'TL',
  TH = 'TH',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  US = 'US',
  UM = 'UM',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  EU = 'EU',
  Value00 = '00',
  Value10 = '10',
}

export enum MarqCommonEnumsCurrencyEnum {
  LTL = 'LTL',
  THB = 'THB',
  CDF = 'CDF',
  HKD = 'HKD',
  IDR = 'IDR',
  CLF = 'CLF',
  TRY = 'TRY',
  ETB = 'ETB',
  ILS = 'ILS',
  MOP = 'MOP',
  SYP = 'SYP',
  AOA = 'AOA',
  SCR = 'SCR',
  HRK = 'HRK',
  GTQ = 'GTQ',
  SLL = 'SLL',
  HUF = 'HUF',
  MXN = 'MXN',
  CVE = 'CVE',
  RUB = 'RUB',
  JMD = 'JMD',
  AWG = 'AWG',
  ZAR = 'ZAR',
  SAR = 'SAR',
  BWP = 'BWP',
  TOP = 'TOP',
  MNT = 'MNT',
  IRR = 'IRR',
  UYU = 'UYU',
  TTD = 'TTD',
  MYR = 'MYR',
  BND = 'BND',
  ANG = 'ANG',
  IMP = 'IMP',
  BTN = 'BTN',
  QAR = 'QAR',
  SHP = 'SHP',
  CUP = 'CUP',
  BMD = 'BMD',
  SDG = 'SDG',
  LAK = 'LAK',
  AED = 'AED',
  CLP = 'CLP',
  ZMK = 'ZMK',
  RSD = 'RSD',
  KGS = 'KGS',
  KES = 'KES',
  XPF = 'XPF',
  AZN = 'AZN',
  XCD = 'XCD',
  AFN = 'AFN',
  KPW = 'KPW',
  ERN = 'ERN',
  AUD = 'AUD',
  NGN = 'NGN',
  BGN = 'BGN',
  TWD = 'TWD',
  LYD = 'LYD',
  NPR = 'NPR',
  PLN = 'PLN',
  COP = 'COP',
  CRC = 'CRC',
  BHD = 'BHD',
  PKR = 'PKR',
  XOF = 'XOF',
  GBP = 'GBP',
  TND = 'TND',
  OMR = 'OMR',
  MZN = 'MZN',
  GYD = 'GYD',
  CZK = 'CZK',
  MGA = 'MGA',
  DKK = 'DKK',
  KYD = 'KYD',
  GGP = 'GGP',
  GIP = 'GIP',
  MVR = 'MVR',
  RON = 'RON',
  RWF = 'RWF',
  NAD = 'NAD',
  JOD = 'JOD',
  XAU = 'XAU',
  VUV = 'VUV',
  BBD = 'BBD',
  UAH = 'UAH',
  CHF = 'CHF',
  BTC = 'BTC',
  SOS = 'SOS',
  CAD = 'CAD',
  GEL = 'GEL',
  LKR = 'LKR',
  BOB = 'BOB',
  MDL = 'MDL',
  NZD = 'NZD',
  MMK = 'MMK',
  LRD = 'LRD',
  VND = 'VND',
  MRO = 'MRO',
  MRU = 'MRU',
  BYR = 'BYR',
  PGK = 'PGK',
  PYG = 'PYG',
  BZD = 'BZD',
  SRD = 'SRD',
  SEK = 'SEK',
  DZD = 'DZD',
  SVC = 'SVC',
  ARS = 'ARS',
  KHR = 'KHR',
  FJD = 'FJD',
  PEN = 'PEN',
  UZS = 'UZS',
  DJF = 'DJF',
  BRL = 'BRL',
  HNL = 'HNL',
  LBP = 'LBP',
  XAG = 'XAG',
  EGP = 'EGP',
  USD = 'USD',
  TJS = 'TJS',
  JEP = 'JEP',
  FKP = 'FKP',
  TMT = 'TMT',
  PHP = 'PHP',
  LSL = 'LSL',
  ISK = 'ISK',
  YER = 'YER',
  VEF = 'VEF',
  SBD = 'SBD',
  MUR = 'MUR',
  CNY = 'CNY',
  PAB = 'PAB',
  BAM = 'BAM',
  NOK = 'NOK',
  KMF = 'KMF',
  BDT = 'BDT',
  INR = 'INR',
  HTG = 'HTG',
  ALL = 'ALL',
  MWK = 'MWK',
  MAD = 'MAD',
  GMD = 'GMD',
  AMD = 'AMD',
  UGX = 'UGX',
  KRW = 'KRW',
  DOP = 'DOP',
  MKD = 'MKD',
  KWD = 'KWD',
  EUR = 'EUR',
  ZWL = 'ZWL',
  TZS = 'TZS',
  BYN = 'BYN',
  ZMW = 'ZMW',
  XAF = 'XAF',
  STD = 'STD',
  STN = 'STN',
  NIO = 'NIO',
  KZT = 'KZT',
  SGD = 'SGD',
  JPY = 'JPY',
  IQD = 'IQD',
  WST = 'WST',
  BIF = 'BIF',
  GHS = 'GHS',
  XDR = 'XDR',
  LVL = 'LVL',
  CUC = 'CUC',
  SZL = 'SZL',
  BSD = 'BSD',
  GNF = 'GNF',
  VES = 'VES',
  SSP = 'SSP',
}

export enum MarqCommonEnumsDemandLetterStatusEnum {
  Requested = 'requested',
  Reviewing = 'reviewing',
  Delivering = 'delivering',
  SellerResponse = 'seller_response',
  ContactFailed = 'contact_failed',
  CaseClosed = 'case_closed',
}

export enum MarqCommonEnumsDomainTypeEnum {
  Ecommerce = 'ecommerce',
  SocialMedia = 'social_media',
  StandAlone = 'stand_alone',
}

export enum MarqCommonEnumsEnforceabilityEnum {
  ToBeChecked = 'to_be_checked',
  Enforceable = 'enforceable',
  NonEnforceable = 'non_enforceable',
  NotSure = 'not_sure',
}

export enum MarqCommonEnumsEnforcementStatusEnum {
  Processing = 'processing',
  Reporting = 'reporting',
  SoftNotice = 'soft_notice',
  Removed = 'removed',
  Denied = 'denied',
  NonEnforceable = 'non_enforceable',
  Tp = 'tp',
}

export enum MarqCommonEnumsIpRightType {
  Trademark = 'trademark',
  Copyright = 'copyright',
  Design = 'design',
  NotFound = 'not_found',
}

export enum MarqCommonEnumsListingStatusEnum {
  Tbtba = 'tbtba',
  ToBeApproved = 'to_be_approved',
  TbaIr = 'tba_ir',
  Irrelevant = 'irrelevant',
  Unprotected = 'unprotected',
  Authorized = 'authorized',
  Authentic = 'authentic',
  Overpriced = 'overpriced',
  Expired = 'expired',
  PreApproved = 'pre_approved',
  PrePublic = 'pre_public',
  PotentialAuthorized = 'potential_authorized',
  IrrelevantPublic = 'irrelevant_public',
  Unavailable = 'unavailable',
  AuthenticPublic = 'authentic_public',
  Checking = 'checking',
  DocPending = 'doc_pending',
  PreSn = 'pre_sn',
  DocDraft = 'doc_draft',
  DocFirst = 'doc_first',
  DocFinal = 'doc_final',
  PostSn = 'post_sn',
  Approved = 'approved',
  Public = 'public',
  DocApproved = 'doc_approved',
  Investigated = 'investigated',
  OldInvestigated = 'old_investigated',
  Pending = 'pending',
  Archived = 'archived',
  Dismissed = 'dismissed',
  Later = 'later',
  Gray = 'gray',
  InvDismissed = 'inv_dismissed',
  InvLater = 'inv_later',
  InvGray = 'inv_gray',
  Tbr = 'tbr',
  Unreportable = 'unreportable',
  InReview = 'in_review',
  OnHold = 'on_hold',
  Tp = 'tp',
  Enforced = 'enforced',
  Denied = 'denied',
  NonEc = 'non_ec',
  SelfRemoved = 'self_removed',
  Trash = 'trash',
}

export enum MarqCommonEnumsMapSortEnum {
  ViolationListings = 'violation_listings',
  ViolationSellers = 'violation_sellers',
  LowestPrice = 'lowest_price',
  LowestDynamicPrice = 'lowest_dynamic_price',
  LowestFinalPrice = 'lowest_final_price',
}

export enum MarqCommonEnumsNonEnforcementReasonEnum {
  NoCounterfeit = 'no_counterfeit',
  NoIpRights = 'no_ip_rights',
  Authentic = 'authentic',
  Irrelevant = 'irrelevant',
  Unavailable = 'unavailable',
}

export enum MarqCommonEnumsOfficialImageSortedByEnum {
  ImageTitle = 'image_title',
  CreatedDate = 'created_date',
}

export enum MarqCommonEnumsOiCollectionSortedByEnum {
  NumberOfImages = 'number_of_images',
  CollectionTitle = 'collection_title',
  CreatedDate = 'created_date',
}

export enum MarqCommonEnumsPerfGroupByEnum {
  None = 'none',
  Marketplace = 'marketplace',
  Country = 'country',
  Asset = 'asset',
  Collection = 'collection',
}

export enum MarqCommonEnumsPerfTimeFrequencyEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum MarqCommonEnumsPotentialAuthorizedReasonEnum {
  Keyword = 'keyword',
  MatchingName = 'matching_name',
  SimilarName = 'similar_name',
  Clustered = 'clustered',
  MarqvisionReview = 'marqvision_review',
}

export enum MarqCommonEnumsPotentialAuthorizedSortedColumnEnum {
  DetectedDate = 'detected_date',
  SellerName = 'seller_name',
}

export enum MarqCommonEnumsReportAbuseIspEnum {
  Kisa = 'kisa',
  Registrar = 'registrar',
  HostingProvider = 'hosting_provider',
  Registry = 'registry',
  Icann = 'icann',
  Payment = 'payment',
  WebsiteBuilder = 'website_builder',
  GoogleSafeBrowsing = 'google_safe_browsing',
}

export enum MarqCommonEnumsReportableReasonEnum {
  TrademarkWordObvious = 'trademark_word_obvious',
  TrademarkOriginDiff = 'trademark_origin_diff',
  TrademarkSizeDiff = 'trademark_size_diff',
  TrademarkMaterialDiff = 'trademark_material_diff',
  TrademarkShapeDiff = 'trademark_shape_diff',
  TrademarkLogoNameConceal = 'trademark_logo_name_conceal',
  TrademarkModelNotExist = 'trademark_model_not_exist',
  TrademarkFreeRiding = 'trademark_free_riding',
  TrademarkOther = 'trademark_other',
  TrademarkMiscellaneous = 'trademark_miscellaneous',
  TrademarkNotFound = 'trademark_not_found',
  CopyrightWordObvious = 'copyright_word_obvious',
  CopyrightOriginDiff = 'copyright_origin_diff',
  CopyrightSizeDiff = 'copyright_size_diff',
  CopyrightMaterialDiff = 'copyright_material_diff',
  CopyrightShapeDiff = 'copyright_shape_diff',
  CopyrightModelNotExist = 'copyright_model_not_exist',
  CopyrightArtworkUse = 'copyright_artwork_use',
  CopyrightOther = 'copyright_other',
  CopyrightMiscellaneous = 'copyright_miscellaneous',
  CopyrightNotFound = 'copyright_not_found',
  DesignNoAuthorization = 'design_no_authorization',
  DesignMiscellaneous = 'design_miscellaneous',
  DesignNotFound = 'design_not_found',
  OfficialImage = 'official_image',
  OfficialVideo = 'official_video',
  NotFoundMiscellaneous = 'not_found_miscellaneous',
  NotFoundWordObvious = 'not_found_word_obvious',
  NotFoundOriginDiff = 'not_found_origin_diff',
  NotFoundSizeDiff = 'not_found_size_diff',
  NotFoundMaterialDiff = 'not_found_material_diff',
  NotFoundShapeDiff = 'not_found_shape_diff',
  NotFoundLogoNameConceal = 'not_found_logo_name_conceal',
  NotFoundModelNotExist = 'not_found_model_not_exist',
  NotFoundFreeRiding = 'not_found_free_riding',
  NotFoundArtworkUse = 'not_found_artwork_use',
  NotFoundOther = 'not_found_other',
  NotFoundNoAuthorization = 'not_found_no_authorization',
  NotFoundUnzuthorizedSales = 'not_found_unzuthorized_sales',
}

export enum MarqCommonEnumsSellerAnalyticsSellerTypeEnum {
  Cluster = 'cluster',
  Ecommerce = 'ecommerce',
  StandAlone = 'stand_alone',
}

export enum MarqCommonEnumsSellerListingStatusGraphTabType {
  AllDays = 'all_days',
  SevenDays = 'seven_days',
  ThirtyDays = 'thirty_days',
  NinetyDays = 'ninety_days',
  OneYears = 'one_years',
}

export enum MarqCommonEnumsSellerSearchSortEnum {
  RiskScore = 'risk_score',
  TotalDetected = 'total_detected',
  TotalRemoved = 'total_removed',
  ActiveListings = 'active_listings',
  SellerName = 'seller_name',
  SalesVolume = 'sales_volume',
}

export enum MarqCommonEnumsShippingTypeEnum {
  Free = 'free',
  Paid = 'paid',
  ConditionalFree = 'conditional_free',
  UnitQuantityPaid = 'unit_quantity_paid',
  RangeQuantityPaid = 'range_quantity_paid',
  Undefined = 'undefined',
}

export enum MarqCommonEnumsSmartRuleSortedByEnum {
  Title = 'title',
  CreatedDate = 'created_date',
  UpdatedDate = 'updated_date',
}

export enum MarqCommonEnumsSortedColumnArchivedPageEnum {
  ArchivedDate = 'archived_date',
}

export enum MarqCommonEnumsSortedColumnEnforcementPageEnum {
  UpdatedDate = 'updated_date',
  RequestedDate = 'requested_date',
}

export enum MarqCommonEnumsSortedOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum MarqCommonEnumsSortedSellerGroupEnum {
  ListingCount = 'listing_count',
  SellerName = 'seller_name',
  Featured = 'featured',
}

export enum MarqCommonEnumsAiClientAIResultEnum {
  LikelyCounterfeit = 'likely_counterfeit',
  AnalysisResult = 'analysis_result',
}

export enum MarqCommonEnumsAiClientTagEnum {
  Trademark = 'trademark',
  TextDetection = 'text_detection',
  ClientRequested = 'client_requested',
  InfringingImage = 'infringing_image',
  OfficialImage = 'official_image',
  RepeatOffender = 'repeat_offender',
  LowPrice = 'low_price',
  TopResult = 'top_result',
}

export enum MarqCommonEnumsClientClientRoleEnum {
  Owner = 'owner',
  Member = 'member',
  LimitedAccess = 'limited_access',
  Admin = 'admin',
}

export enum MarqCommonEnumsClientClientTypeEnum {
  Counterfeit = 'counterfeit',
  UnauthorizedSales = 'unauthorized_sales',
  Impersonation = 'impersonation',
  Piracy = 'piracy',
}

export enum MarqCommonEnumsCrCRUrlStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum MarqCommonEnumsCrClientRequestChannelTypeEnum {
  Ecommerce = 'ecommerce',
  Website = 'website',
  None = 'none',
}

export enum MarqCommonEnumsCrClientRequestEnforcementTypeEnum {
  PrePublic = 'pre_public',
  Enforced = 'enforced',
}

export enum MarqCommonEnumsCrClientRequestTypeEnum {
  Url = 'url',
  Other = 'other',
}

export enum MarqCommonEnumsCrClientTaskFileTypeEnum {
  All = 'all',
  Document = 'document',
  Image = 'image',
  Sheet = 'sheet',
}

export enum MarqCommonEnumsCrClientTaskMessageTypeEnum {
  Open = 'open',
  Reply = 'reply',
  Reopen = 'reopen',
}

export enum MarqCommonEnumsCrClientTaskStatusEnum {
  Opened = 'opened',
  Reopened = 'reopened',
  Replied = 'replied',
  Completed = 'completed',
}

export enum MarqCommonEnumsCrCrUrlProgressStatusEnum {
  MarqVisionUnderReview = 'MarqVision under review',
  Detected = 'Detected',
  TestPurchaseOffered = 'Test Purchase Offered',
  ReviewNeeded = 'Review needed',
  UnderReview = 'Under review',
  Archived = 'Archived',
  EnforcementInProgress = 'Enforcement in Progress',
  Removed = 'Removed',
  CaseClosed = 'Case closed',
  RemovalDenied = 'Removal Denied',
  AuthorizedSellers = 'Authorized sellers',
  AuthorizedWebsites = 'Authorized websites',
  LikelyToBeAuthentic = 'Likely to be authentic',
  URLExpired = 'URL expired',
  NotEnforceable = 'Not enforceable',
  Value = '-',
  InvalidURL = 'Invalid URL',
}

export enum MarqCommonEnumsCvassistantCvAssistantResultEnum {
  Infringing = 'infringing',
  NotInfringing = 'not_infringing',
  Undecidable = 'undecidable',
  NoResponse = 'no_response',
}

export enum MarqCommonEnumsCvassistantCvAssistantStatusEnum {
  Detected = 'detected',
  Requested = 'requested',
  Approved = 'approved',
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  UrlRemoved = 'url_removed',
  Reported = 'reported',
  Dismissed = 'dismissed',
  Authorized = 'authorized',
}

export enum MarqCommonEnumsIpCopyrightType {
  Image = 'image',
  Content = 'content',
  Illust = 'illust',
  Celeb = 'celeb',
  Video = 'video',
  Object = 'object',
}

export enum MarqCommonEnumsIpCounterfeitType {
  WordObvious = 'word_obvious',
  OriginDiff = 'origin_diff',
  SizeDiff = 'size_diff',
  MaterialDiff = 'material_diff',
  ShapeDiff = 'shape_diff',
  LogoNameConceal = 'logo_name_conceal',
  ModelNotExist = 'model_not_exist',
  FreeRiding = 'free_riding',
  ArtworkUse = 'artwork_use',
  VideoUse = 'video_use',
  Other = 'other',
  Misc = 'misc',
  NoAuthorization = 'no_authorization',
  ImageTheft = 'image_theft',
  NotFound = 'not_found',
  UnauthorizedSales = 'unauthorized_sales',
}

export enum MarqCommonEnumsPerfPerfOverviewFieldEnum {
  Detected = 'detected',
  EnforcementRequested = 'enforcement_requested',
  Removed = 'removed',
}

export enum MarqCommonEnumsPerfPerformaceImpersonationComponentEnum {
  FunnelChart = 'funnel_chart',
  Insight = 'insight',
  Reporting = 'reporting',
  Compliance = 'compliance',
  ProcessingTime = 'processing_time',
}

export enum MarqCommonEnumsRuleDescriptionContainsTypeEnum {
  All = 'all',
  Any = 'any',
}

export enum MarqCommonEnumsRulePriceRelativeReferenceTypeEnum {
  Asset = 'asset',
  Model = 'model',
}

export enum MarqCommonEnumsRuleSmartRuleActionEnum {
  Tag = 'tag',
  ArchiveDismissed = 'archive_dismissed',
  ArchiveReviewLater = 'archive_review_later',
  ArchiveGray = 'archive_gray',
  Archived = 'archived',
  Enforcement = 'enforcement',
}

export enum MarqCommonEnumsRuleSmartRuleConditionTypeEnum {
  And = 'and',
  Or = 'or',
  Assets = 'assets',
  Domain = 'domain',
  TrademarkedLogoUsed = 'trademarked_logo_used',
  TrademarkedTextUsed = 'trademarked_text_used',
  RepeatOffenders = 'repeat_offenders',
  TopSearchResults = 'top_search_results',
  LowPrice = 'low_price',
  PriceFixed = 'price_fixed',
  PriceRelative = 'price_relative',
  CopyrightedImage = 'copyrighted_image',
  InfringingImage = 'infringing_image',
  TitleContains = 'title_contains',
  DescriptionContains = 'description_contains',
  Seller = 'seller',
  SellerContains = 'seller_contains',
}

export enum MarqCommonEnumsRuleSmartRuleStatusEnum {
  Activated = 'activated',
  Deactivated = 'deactivated',
  Processing = 'processing',
}

export enum MarqCommonEnumsRuleTitleContainsTypeEnum {
  All = 'all',
  Any = 'any',
  None = 'none',
}

export enum MarqCommonEnumsSellerintelSellerClusterDataSortByEnum {
  SellerName = 'seller_name',
  BusRegNum = 'bus_reg_num',
  OnlineMarkNum = 'online_mark_num',
  PhoneNum = 'phone_num',
  Email = 'email',
  Address = 'address',
  CompName = 'comp_name',
  LegRep = 'leg_rep',
  ShopName = 'shop_name',
  Market = 'market',
  MarketCountryCode = 'market_country_code',
  ListingImages = 'listing_images',
  ListingTitle = 'listing_title',
  ListingDesc = 'listing_desc',
  Detected = 'detected',
  Removed = 'removed',
  Active = 'active',
  SalesVolume = 'sales_volume',
}

export enum MarqCommonEnumsSellerintelSellerClusterStatusEnum {
  ActCalculating = 'act_calculating',
  ActActual = 'act_actual',
  Deactivated = 'deactivated',
}

export enum MarqCommonEnumsSellerintelSellerIntelClusterSortBy {
  SCount = 's_count',
  MCount = 'm_count',
  Detected = 'detected',
  Removed = 'removed',
  SVol = 's_vol',
  StCount = 'st_count',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsCountriesSortBy {
  SellerCount = 'seller_count',
  MarketplaceCount = 'marketplace_count',
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsDomainsSortBy {
  SellerCount = 'seller_count',
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsSellersSortBy {
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelMappingLevel {
  Level1 = 'level_1',
  Level2 = 'level_2',
  Level3 = 'level_3',
  Level4 = 'level_4',
}

export enum MarqCommonEnumsStripeBillingHistoryStatusEnum {
  Success = 'success',
  Failed = 'failed',
  Refunded = 'refunded',
}

export enum MarqCommonEnumsStripeStripeCardBrandEnum {
  Amex = 'amex',
  Diners = 'diners',
  Discover = 'discover',
  EftposAu = 'eftpos_au',
  Jcb = 'jcb',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Visa = 'visa',
  Unknown = 'unknown',
}

export enum MarqCommonEnumsSwSWActionTypeEnum {
  GoogleDelisting = 'google_delisting',
  SoftNotice = 'soft_notice',
  ReportAbuse = 'report_abuse',
  Udrp = 'udrp',
}

export enum MarqCommonEnumsSwSWStatusEnum {
  ThirdFetched = 'third_fetched',
  ToBeApproved = 'to_be_approved',
  Approved = 'approved',
  Public = 'public',
  InvestigatePending = 'investigate_pending',
  InvInProgress = 'inv_in_progress',
  Investigated = 'investigated',
  ActionTaken = 'action_taken',
  NonEnforceable = 'non_enforceable',
  Irrelevant = 'irrelevant',
  Authorized = 'authorized',
  Tp = 'tp',
  Trash = 'trash',
  Ignore = 'ignore',
  Removed = 'removed',
  Denied = 'denied',
  Dissmissed = 'dissmissed',
  InvCompleted = 'inv_completed',
  NotUse = 'not_use',
}

export enum MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum {
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Monitoring = 'monitoring',
  Dismissed = 'dismissed',
}

export enum MarqCommonEnumsSwWebsiteContentsTabEnum {
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
  Tp = 'tp',
}

export enum MarqCommonEnumsSwWebsiteDelistingProgressEnum {
  Reviewing = 'reviewing',
  Reported = 'reported',
  Delisted = 'delisted',
  Denied = 'denied',
}

export enum MarqCommonEnumsSwWebsiteReportProgressEnum {
  Reviewing = 'reviewing',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
}

export enum MarqCommonEnumsSwWebsiteSortedColumnEnum {
  DetectedDate = 'detected_date',
  RequestDate = 'request_date',
  PublicDate = 'public_date',
  UpdatedDate = 'updated_date',
  DomainName = 'domain_name',
  Featured = 'featured',
  ProgressDate = 'progress_date',
  RemovedDate = 'removed_date',
  ActionTakenDate = 'action_taken_date',
}

export enum MarqCommonEnumsTpTPImageTypeEnum {
  Waybill = 'waybill',
  Package = 'package',
  Product = 'product',
  Labels = 'labels',
  Others = 'others',
  Report = 'report',
  Image = 'image',
}

export enum MarqCommonEnumsTpTPTypeEnum {
  Standard = 'standard',
  Basic = 'basic',
}

export interface MarqCommonModelLocalDateRange {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start?: string | null;
}

export interface MarqCommonModelOffsetDateTimeRange {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  end: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  start: string;
}

export type MarqCommonModelRuleSmartRuleConditionForClient =
  | MarqCommonModelRuleSmartRuleConditionForClientAnd
  | MarqCommonModelRuleSmartRuleConditionForClientAssets
  | MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImage
  | MarqCommonModelRuleSmartRuleConditionForClientDescriptionContains
  | MarqCommonModelRuleSmartRuleConditionForClientDomain
  | MarqCommonModelRuleSmartRuleConditionForClientInfringingImage
  | MarqCommonModelRuleSmartRuleConditionForClientLowPrice
  | MarqCommonModelRuleSmartRuleConditionForClientOr
  | MarqCommonModelRuleSmartRuleConditionForClientPriceFixed
  | MarqCommonModelRuleSmartRuleConditionForClientPriceRelative
  | MarqCommonModelRuleSmartRuleConditionForClientRepeatOffenders
  | MarqCommonModelRuleSmartRuleConditionForClientSeller
  | MarqCommonModelRuleSmartRuleConditionForClientSellerContains
  | MarqCommonModelRuleSmartRuleConditionForClientTitleContains
  | MarqCommonModelRuleSmartRuleConditionForClientTopSearchResults
  | MarqCommonModelRuleSmartRuleConditionForClientTrademarkedLogoUsed
  | MarqCommonModelRuleSmartRuleConditionForClientTrademarkedTextUsed;

export interface MarqCommonModelRuleSmartRuleConditionForClientAnd {
  conditions: MarqCommonModelRuleSmartRuleConditionForClient[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientAssets {
  asset_ids?: number[] | null;
  model_ids?: number[] | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImage {
  all: boolean;
  entire_official_image_collection_ids?: (number | null)[];
  partial_official_image_collections?:
    | MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImageOfficialImageCollection[]
    | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImageOfficialImageCollection {
  /** @format int32 */
  official_image_collection_id?: number | null;
  official_image_ids: number[];
}

export interface MarqCommonModelRuleSmartRuleConditionForClientDescriptionContains {
  contains_type: MarqCommonEnumsRuleDescriptionContainsTypeEnum;
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientDomain {
  domain_ids: number[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientInfringingImage {
  all: boolean;
  infringing_image_collection_ids?: (number | null)[];
  infringing_image_ids?: number[] | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientLowPrice {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientOr {
  conditions: MarqCommonModelRuleSmartRuleConditionForClient[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientPriceFixed {
  currency: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  max?: number | null;
  /** @format double */
  min?: number | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientPriceRelative {
  /** @format double */
  max?: number | null;
  /** @format double */
  min?: number | null;
  reference: MarqCommonEnumsRulePriceRelativeReferenceTypeEnum;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientRepeatOffenders {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientSeller {
  seller_names: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientSellerContains {
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTitleContains {
  contains_type: MarqCommonEnumsRuleTitleContainsTypeEnum;
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTopSearchResults {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTrademarkedLogoUsed {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTrademarkedTextUsed {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export type MarqCommonProtocolEmptyRequest = object;

export type MarqCommonProtocolEmptyResponse = object;

export interface MarqCommonProtocolFileResponse {
  /** @format byte */
  bytes: string;
  content_type: IoKtorHttpContentType;
  filename: string;
}

export interface MonitoringCommonViewProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringCommonViewProtocolsExcelExportByListingIdRequest {
  listing_id_list: number[];
}

export interface MonitoringCommonViewProtocolsGetAllListingIdRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsGetAllListingIdResponse {
  listing_id_list: number[];
}

export interface MonitoringCommonViewProtocolsGetCountRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsGetCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface MonitoringCommonViewProtocolsGetCountProgressRequest {
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum;
}

export interface MonitoringCommonViewProtocolsGetCountProgressResponse {
  /** @format int32 */
  reporting: number;
  /** @format int32 */
  soft_notice: number;
}

export interface MonitoringEnforcementTPProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringEnforcementTPProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringEnforcementTPProtocolsExcelExportByListingIdRequest {
  listing_id_list?: number[] | null;
}

export interface MonitoringEnforcementTPProtocolsGetAllListingIdRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringEnforcementTPProtocolsGetAllListingIdResponse {
  listing_id_list: number[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringEnforcementTPProtocolsGetCountAndRecentlyListingRequest {
  /** @format int32 */
  brand_id?: number | null;
  domain_type?: MarqCommonEnumsDomainTypeEnum[] | null;
}

export interface MonitoringEnforcementTPProtocolsGetCountAndRecentlyListingResponse {
  /** @format int32 */
  purchase_count: number;
  /** @format int32 */
  reviewing_count: number;
}

export interface MonitoringEnforcementTPProtocolsGetEnforcementTPListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  model_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringEnforcementTPProtocolsGetEnforcementTPListingsResponse {
  asset_exists: boolean;
  listings: MarqBrandModelResponseEnforcementTPListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringEnforcementTPProtocolsGetExportListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringEnforcementTPProtocolsGetNoteDownloadUrlRequest {
  /** @format int32 */
  doc_id: number;
  /** @format int32 */
  listing_id: number;
}

export interface MonitoringEnforcementTPProtocolsGetNoteDownloadUrlResponse {
  url: string;
}

export interface MonitoringFilterProtocolPagingRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  in_search_keyword_filter?: string | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  search_after: KotlinAny[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  /** @format int32 */
  size: number;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringFilterProtocolRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringFilterProtocolResponse {
  /** @format int32 */
  count?: number | null;
  filter_display: boolean;
  list: MonitoringFilterProtocolResponseFilterItem[];
  search_after?: KotlinAny[] | null;
}

export interface MonitoringFilterProtocolResponseFilterItem {
  /** @format int32 */
  count?: number | null;
  id: KotlinAny;
  image_url?: string | null;
  list?: MonitoringFilterProtocolResponseFilterItem[] | null;
  text: string;
}

export interface MonitoringImageViewProtocolsGetGroupAllListingIdsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  /** @format int32 */
  group_image_id: number;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetGroupAllListingIdsResponse {
  listing_ids: number[];
}

export interface MonitoringImageViewProtocolsGetGroupListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  /** @format int32 */
  group_image_id: number;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetGroupListingsResponse {
  listings: MarqBrandModelResponseMonitoringListingResponse[];
}

export interface MonitoringImageViewProtocolsGetImageGroupsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetImageGroupsResponse {
  listing_groups: MonitoringImageViewProtocolsGetImageGroupsResponseImageGroup[];
}

export interface MonitoringImageViewProtocolsGetImageGroupsResponseImageGroup {
  /** @format int32 */
  group_image_id?: number | null;
  listing_list: MarqBrandModelResponseMonitoringListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringListViewProtocolsGetListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringListViewProtocolsGetListingsResponse {
  asset_exists: boolean;
  listings: MarqBrandModelResponseMonitoringListingResponse[];
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsPotentialAuthorizedSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportBySellerIdsRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
}

export interface MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsResponse {
  sellers: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsGetCountRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
}

export interface MonitoringPotentialAuthorizedProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
  is_new: boolean;
}

export interface MonitoringPotentialAuthorizedProtocolsGetListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  /** @format int32 */
  seller_id: number;
  seller_name_filter?: string[] | null;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsGetListingsResponse {
  domain_name?: string | null;
  listing_list: MarqBrandModelResponsePotentialAuthorizedListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsGetSellersRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  model_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsGetSellersResponse {
  sellers: MonitoringPotentialAuthorizedProtocolsPotentialAuthorizedSeller[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsPotentialAuthorizedSeller {
  /** @format int32 */
  count: number;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  matched_keyword?: string | null;
  reason_code: MarqCommonEnumsPotentialAuthorizedReasonEnum;
  reason_text: string;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
}

export interface MonitoringSellerViewProtocolsGetListingIdForSellerRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name_filter?: string[] | null;
  seller_sorted_column: MarqCommonEnumsSortedSellerGroupEnum;
  seller_sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetListingIdForSellerResponse {
  /** @format int32 */
  count: number;
  listing_ids: number[];
}

export interface MonitoringSellerViewProtocolsGetSellerDetailsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  seller_id: number;
}

export interface MonitoringSellerViewProtocolsGetSellerDetailsResponse {
  seller_detail: MarqBrandCoreModelResponseSellerDetailResponse;
}

export interface MonitoringSellerViewProtocolsGetSellerListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetSellerListingsResponse {
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  listing_list: MarqBrandModelResponseMonitoringListingResponse[];
  seller_page_url?: string | null;
  snapshot_path?: string | null;
  /** @format int32 */
  total_count: number;
}

export interface MonitoringSellerViewProtocolsGetSellersRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  currency?: MarqCommonEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  seller_sorted_column: MarqCommonEnumsSortedSellerGroupEnum;
  seller_sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetSellersResponse {
  sellers: MarqBrandModelResponseSellerCountResponse[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsDeleteAllCustomTagRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  domain_id_filter?: number[] | null;
  search?: string | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_sub_tab?: MarqBrandEnumsWebsiteContentsTpTabEnum;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  domain_id_filter?: number[] | null;
  search?: string | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_sub_tab?: MarqBrandEnumsWebsiteContentsTpTabEnum;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit?: number | null;
  search?: string | null;
  search_after?: KotlinAny[] | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_sub_tab?: MarqBrandEnumsWebsiteContentsTpTabEnum;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsRequest {
  /** @format int32 */
  brand_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  domain_id_filter?: number[] | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_sub_tab?: MarqBrandEnumsWebsiteContentsTpTabEnum;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsResponse {
  /** @format int32 */
  id: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetTpSubTabCountRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetTpSubTabCountResponse {
  /** @format int32 */
  purchase_count: number;
  /** @format int32 */
  reviewing_count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest {
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailResponse {
  website_detail: MarqBrandModelResponseWebsiteWebsiteContentsDetailResponse;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest {
  /** @format int32 */
  brand_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit?: number | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_sub_tab?: MarqBrandEnumsWebsiteContentsTpTabEnum;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListResponse {
  website_list: MonitoringWebsiteContentWebsiteContentCommonProtocolsWebsiteContentsListing[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedResponse {
  /** @format int32 */
  affected: number;
  domain_name: string;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseRequest {
  tp_type: MarqCommonEnumsTpTPTypeEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseResponse {
  success: boolean;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusRequest {
  from_status: MarqCommonEnumsSwSWStatusEnum;
  to_status: MarqCommonEnumsSwSWStatusEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsWebsiteContentsListing {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_url: string;
  full_url: string;
  google_delisting_status?: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
  infringing_contents_status?: MarqCommonEnumsSwWebsiteReportProgressEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_reported_date?: string | null;
  thumbnail_url?: string | null;
  title: string;
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsDeleteAllCustomTagRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_filter?: MarqCommonEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  logo_detection_filter?: boolean | null;
  search?: string | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_filter?: MarqCommonEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  logo_detection_filter?: boolean | null;
  search?: string | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_filter?: MarqCommonEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  logo_detection_filter?: boolean | null;
  search?: string | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_filter?: MarqCommonEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  logo_detection_filter?: boolean | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsResponse {
  /** @format int32 */
  id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest {
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailResponse {
  website_detail: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailResponse;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_filter?: MarqCommonEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  detected_date?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit?: number | null;
  logo_detection_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListResponse {
  website_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesListing[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedResponse {
  /** @format int32 */
  affected: number;
  domain_name: string;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsTemporaryEnumValueResponse {
  tmp_enum: MarqCommonEnumsSwWebsiteSortedColumnEnum;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusRequest {
  from_status: MarqCommonEnumsSwSWStatusEnum;
  to_status: MarqCommonEnumsSwSWStatusEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface PerfCommercePerformanceProtocolsGetClientCountryListResponse {
  country_list: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisRequest {
  asset_id_list: number[];
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisResponse {
  data: PerfCommercePerformanceProtocolsGetCohortAnalysisResponseCohortMonthData[];
  /** @format double */
  removal_rate: number;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisResponseCohortMonthData {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  enforcement_req_count: number;
  /** @format int64 */
  removed_count: number;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisCSVNewRequest {
  asset_id_list: number[];
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetCohortFilterNewRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetCohortFilterNewResponse {
  asset_list: MarqBrandCoreModelResponseComboBoxIntValueLabelResponse[];
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateResponse {
  /** @format double */
  denied_percent: number;
  /** @format double */
  enforced_percent: number;
  /** @format double */
  in_review_percent: number;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponse {
  rate_list: PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponseRate[];
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponseRate {
  domain_name: string;
  /** @format double */
  percent: number;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueResponse {
  chart_value_list: PerfCommercePerformanceProtocolsGetEnforcedValueResponseChartValue[];
  /** @format int64 */
  enforced_value: number;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueResponseChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  value: number;
}

export interface PerfCommercePerformanceProtocolsGetExpertServicesRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetExpertServicesResponse {
  /** @format int64 */
  demand_letter_count: number;
  /** @format int64 */
  tp_count: number;
}

export interface PerfCommercePerformanceProtocolsGetImpactedSellerRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqCommonEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetImpactedSellerResponse {
  /** @format int64 */
  impacted_seller_count: number;
  /** @format int64 */
  repeat_offender_count: number;
  /** @format int32 */
  repeat_offender_percent: number;
}

export interface PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeResponse {
  chart_value_list: MarqBrandModelResponseListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersResponse {
  top_sellers: PerfCommercePerformanceProtocolsGetTopInfringingSellersResponseTopSeller[];
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersResponseTopSeller {
  /** @format int32 */
  id: number;
  marketplace_name: string;
  name: string;
  /** @format int64 */
  removed_count: number;
  seller_string_id: string;
}

export interface PerfCommercePerformanceProtocolsGetWebsiteCountsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetWebsiteCountsResponse {
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  enforced_count: number;
  /** @format int64 */
  enforcement_req_count: number;
  /** @format int64 */
  udrp_count: number;
}

export interface PerfCommercePerformanceReportProtocolsGetListRequest {
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface PerfCommercePerformanceReportProtocolsGetListResponse {
  list: PerfCommercePerformanceReportProtocolsGetListResponseReport[];
}

export interface PerfCommercePerformanceReportProtocolsGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateResponse {
  /** @format double */
  denied_percent: number;
  /** @format double */
  enforced_percent: number;
  /** @format double */
  four_week_percent: number;
  /** @format double */
  in_review_percent: number;
  /** @format double */
  two_week_percent: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponse {
  chart_value_list: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponseCompRateChartValue[];
  frequency_filter_list: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponseCompRateChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponse {
  top_data_list: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponseTopData[];
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponseTopData {
  domain_name: string;
  /** @format double */
  rate_percent: number;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetListingCountByAnalysisTypeRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetListingCountByAnalysisTypeResponse {
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  enforcement_requested_count: number;
  /** @format int64 */
  removed_count: number;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetListingsOverTimeRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetListingsOverTimeResponse {
  chart_value_list: MarqBrandModelResponseListingsChartValue[];
  frequency_filter_list: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
  /** @format int64 */
  total_count: number;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetListingsOverTimeCsvRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetRemovedDataRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetRemovedDataResponse {
  /** @format int64 */
  enforced_value: number;
  /** @format int64 */
  removed_units: number;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopAssetCsvRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopAssetDataRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopAssetDataResponse {
  top_data_list: MarqBrandModelResponseTopData[];
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopCountryCsvRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopCountryDataRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopCountryDataResponse {
  top_data_list: MarqBrandModelResponseTopData[];
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopMarketplaceCsvRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopMarketplaceDataRequest {
  analysis_type: MarqCommonEnumsPerfPerfOverviewFieldEnum;
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: MarqCommonEnumsPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsEnfAnalysisProtocolsGetTopMarketplaceDataResponse {
  top_data_list: MarqBrandModelResponseTopData[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponse {
  impacted_sellers: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData;
  /** @format double */
  repeat_offender_percent: number;
  repeat_offenders: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData {
  /** @format int64 */
  total_detected_listings: number;
  /** @format int64 */
  total_removed_listings: number;
  /** @format int64 */
  total_sellers: number;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponse {
  marketplace_filter: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponseCountryMarkets[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponseCountryMarkets {
  country: string;
  marketplace_list: MarqBrandCoreModelResponseComboBoxIntValueLabelResponse[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  marketplace_filter: number[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponse {
  seller_list: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponseTopInfringingSeller[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponseTopInfringingSeller {
  /** @format int64 */
  active_count: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  first_detected?: string | null;
  /** @format int32 */
  id: number;
  marketplace_name: string;
  /** @format int64 */
  removed_count: number;
  seller_name: string;
  seller_string_id: string;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list: MarqCommonEnumsCountryCodeEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  marketplace_filter: number[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponse {
  /** @format double */
  rate: number;
  rate_by_channel: PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponse[];
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponse {
  channel_name: string;
  grouped_count_list?:
    | PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponseGroupedCount[]
    | null;
  /** @format double */
  total_rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponseGroupedCount {
  name: string;
  /** @format double */
  rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetExportFileRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetExportFileResponse {
  /** @format int32 */
  id: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponse {
  in_period: PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse;
  total_activity: PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse {
  /** @format int32 */
  detected: number;
  /** @format double */
  detected_rate: number;
  /** @format int32 */
  removed: number;
  /** @format double */
  removed_rate: number;
  /** @format int32 */
  reported: number;
  /** @format double */
  reported_rate: number;
  /** @format int32 */
  scanned: number;
  /** @format double */
  scanned_rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponse {
  channel: PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseChannelResponse[];
  monitored: PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseMonitoredResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseChannelResponse {
  /** @format int32 */
  count: number;
  name: string;
  type: MarqCommonEnumsChannelTypeEnum;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseMonitoredResponse {
  /** @format int32 */
  malicious: number;
  /** @format int32 */
  post_malicious: number;
  /** @format int32 */
  pre_malicious: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponse {
  time_to_detected: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
  time_to_removed: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
  time_to_reported: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse {
  domain_names?: string | null;
  social_media?: string | null;
  website_contents?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponse {
  activity_by_channel: PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponse[];
  activity_count: PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityCountResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponse {
  channel_name: string;
  grouped_count_list?:
    | PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponseGroupedCount[]
    | null;
  /** @format int32 */
  reported_count: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponseGroupedCount {
  /** @format int32 */
  count: number;
  name: string;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityCountResponse {
  /** @format int32 */
  activity: number;
  /** @format double */
  avg_activity: number;
  /** @format int32 */
  reported: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetVisibleComponentResponse {
  component_list: MarqCommonEnumsPerfPerformaceImpersonationComponentEnum[];
}

export interface PortfolioAssetProtocolsBulkUpdateAssetRequest {
  asset_ids: number[];
  currency?: MarqCommonEnumsCurrencyEnum;
  /** @format double */
  min_price?: number | null;
  related_ip_doc_ids?: number[] | null;
}

export interface PortfolioAssetProtocolsCreateAssetByPresignedRequest {
  asset_name: string;
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqCommonEnumsCurrencyEnum;
  image_file_url_list: string[];
  /** @format double */
  min_price: number;
  product_code?: string[] | null;
  product_url?: string | null;
  related_ip_doc_ids: number[];
}

export interface PortfolioAssetProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface PortfolioAssetProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsDeleteAssetRequest {
  /** @format int32 */
  asset_id: number;
}

export interface PortfolioAssetProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponse {
  brand_collection: PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioCollection[];
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseCollectionData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioCollection {
  brand: PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioData;
  collection_tree: PortfolioAssetProtocolsGetAllCollectionsResponseCollectionData[];
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PortfolioAssetProtocolsGetAssetRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioAssetProtocolsGetAssetResponse {
  /** @format int32 */
  asset_brand_id: number;
  /** @format int32 */
  asset_collection_id?: number | null;
  asset_currency: MarqCommonEnumsCurrencyEnum;
  asset_full_ip_doc_list: MarqBrandDataModelAssetDataFullIpDoc[];
  /** @format int32 */
  asset_id: number;
  asset_images: string[];
  /** @format double */
  asset_min_price?: number | null;
  asset_name: string;
  asset_product_code?: string[] | null;
  asset_product_url?: string | null;
  asset_related_ip_doc_ids: number[];
}

export interface PortfolioAssetProtocolsGetAssetListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  collection_id?: number | null;
}

export interface PortfolioAssetProtocolsGetAssetListResponse {
  asset_list: PortfolioAssetProtocolsGetAssetListResponseAsset[];
}

export interface PortfolioAssetProtocolsGetAssetListResponseAsset {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqCommonEnumsCurrencyEnum;
  /** @format int32 */
  id: number;
  images: string[];
  /** @format double */
  min_price?: number | null;
  name: string;
  product_code?: string[] | null;
  product_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface PortfolioAssetProtocolsGetAssetPresignedUrlRequest {
  file_name: string;
}

export interface PortfolioAssetProtocolsGetAssetPresignedUrlResponse {
  url: string;
}

export interface PortfolioAssetProtocolsGetIpDocumentsRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioAssetProtocolsGetIpDocumentsResponse {
  ip_documents: MarqBrandDataModelIpDocByClass[];
}

export interface PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetRequest {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetResponse {
  ip_document_ids: number[];
}

export interface PortfolioAssetProtocolsUpdateAssetByPresignedRequest {
  added_image_string_list: string[];
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqCommonEnumsCurrencyEnum;
  deleted_image_string_list: string[];
  /** @format int32 */
  id: number;
  image_file_url_list?: string[] | null;
  /** @format double */
  min_price: number;
  name: string;
  product_code?: string[] | null;
  product_url?: string | null;
  related_ip_doc_ids: number[];
  urls?: string[] | null;
}

export interface PortfolioAssetProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
  related_ip_doc_ids?: number[] | null;
}

export interface PortfolioCopyrightsProtocolsAddCopyrightRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
  list: PortfolioCopyrightsProtocolsAddCopyrightRequestItem[];
}

export interface PortfolioCopyrightsProtocolsAddCopyrightRequestItem {
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsAddDocumentRequest {
  /** @format int32 */
  brand_id: number;
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name: string;
  file_url: string;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioCopyrightsProtocolsAddDocumentResponse {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsDeleteCopyrightRequest {
  /** @format int32 */
  doc_id: number;
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsDeleteDocumentRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsRequest {
  /** @format int32 */
  doc_id: number;
  sorted_order_enum: MarqCommonEnumsSortedOrderEnum;
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsResponse {
  doc_name: string;
  list: PortfolioCopyrightsProtocolsGetCopyrightsResponseCopyright[];
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsResponseCopyright {
  /** @format int32 */
  id: number;
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsGetDocumentDetailsRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentDetailsResponse {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  /** @format int32 */
  id: number;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentsRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentsResponse {
  list: PortfolioCopyrightsProtocolsGetDocumentsResponseDocument[];
}

export interface PortfolioCopyrightsProtocolsGetDocumentsResponseDocument {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  /** @format int32 */
  id: number;
  licensee?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  rights_owner: string;
}

export interface PortfolioCopyrightsProtocolsUpdateCopyrightRequest {
  /** @format int32 */
  doc_id: number;
  /** @format int32 */
  id: number;
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsUpdateDocumentRequest {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name: string;
  file_url: string;
  /** @format int32 */
  id: number;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioDesignProtocolsAddDesignRequest {
  /** @format int32 */
  brand_id: number;
  countries: MarqCommonEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  ip_class: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
}

export interface PortfolioDesignProtocolsAddDesignResponse {
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsDeleteDesignRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsGetDesignDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsGetDesignDetailResponse {
  countries: MarqCommonEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  ip_class?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  thumbnail_url?: string | null;
}

export interface PortfolioDesignProtocolsGetDesignListResponse {
  design_list: PortfolioDesignProtocolsGetDesignListResponseDesign[];
}

export interface PortfolioDesignProtocolsGetDesignListResponseDesign {
  countries: MarqCommonEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  ip_class?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  rights_licensee?: string | null;
  rights_owner?: string | null;
  thumbnail?: string | null;
}

export interface PortfolioDesignProtocolsRequest {
  /** @format int32 */
  brand_id: number;
  country?: MarqCommonEnumsCountryCodeEnum[] | null;
  expiration_date?: MarqCommonModelOffsetDateTimeRange;
  ip_class?: string[] | null;
  is_expired_filter?: boolean | null;
  is_expiring_soon_filter?: boolean | null;
  keyword?: string | null;
  registered_date?: MarqCommonModelOffsetDateTimeRange;
}

export interface PortfolioDesignProtocolsUpdateDesignRequest {
  /** @format int32 */
  brand_id: number;
  countries: MarqCommonEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  ip_class: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
}

export interface PortfolioIpDocProtocolsAddBrandRequest {
  copyright_footer?: string | null;
  logo_url: string;
  name: string;
}

export interface PortfolioIpDocProtocolsAddBrandResponse {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsDeleteBrandRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsGetBrandDetailRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsGetBrandDetailResponse {
  copyright_footer?: string | null;
  /** @format int32 */
  copyrights: number;
  /** @format int32 */
  designs: number;
  logo_url: string;
  name: string;
  /** @format int32 */
  trademarks: number;
}

export interface PortfolioIpDocProtocolsGetBrandListResponse {
  brand_list: PortfolioIpDocProtocolsGetBrandListResponseBrand[];
}

export interface PortfolioIpDocProtocolsGetBrandListResponseBrand {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  copyrights: number;
  /** @format int32 */
  designs: number;
  logo_url: string;
  name: string;
  /** @format int32 */
  trademarks: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface PortfolioIpDocProtocolsGetDownloadUrlRequest {
  url: string;
}

export interface PortfolioIpDocProtocolsGetDownloadUrlResponse {
  url: string;
}

export interface PortfolioIpDocProtocolsGetLicenseeListResponse {
  list: PortfolioIpDocProtocolsGetLicenseeListResponseRightsLicensee[];
}

export interface PortfolioIpDocProtocolsGetLicenseeListResponseRightsLicensee {
  /** @format int32 */
  licensee_id: number;
  licensee_name: string;
}

export interface PortfolioIpDocProtocolsGetOwnerListResponse {
  list: PortfolioIpDocProtocolsGetOwnerListResponseRightsOwner[];
}

export interface PortfolioIpDocProtocolsGetOwnerListResponseRightsOwner {
  /** @format int32 */
  owner_id: number;
  owner_name: string;
}

export interface PortfolioIpDocProtocolsGetUploadUrlRequest {
  /** @format int32 */
  brand_id?: number | null;
  file_name: string;
}

export interface PortfolioIpDocProtocolsGetUploadUrlResponse {
  url: string;
}

export interface PortfolioIpDocProtocolsUpdateBrandRequest {
  /** @format int32 */
  brand_id: number;
  copyright_footer?: string | null;
  logo_url: string;
  name: string;
}

export interface PortfolioTrademarkProtocolsAddTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  class_list: string[];
  countries: MarqCommonEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
  trademark_text?: string[] | null;
}

export interface PortfolioTrademarkProtocolsAddTrademarkResponse {
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsDeleteTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsGetTrademarkDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsGetTrademarkDetailResponse {
  class_list: string[];
  countries: MarqCommonEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  thumbnail_url?: string | null;
  trademark_text: string[];
}

export interface PortfolioTrademarkProtocolsGetTrademarkListResponse {
  trademark_list: PortfolioTrademarkProtocolsGetTrademarkListResponseTrademark[];
}

export interface PortfolioTrademarkProtocolsGetTrademarkListResponseTrademark {
  class_list?: string[] | null;
  countries: MarqCommonEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  exclusive_licensee?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  rights_owner?: string | null;
  thumbnail?: string | null;
  trademark_text?: string[] | null;
}

export interface PortfolioTrademarkProtocolsRequest {
  /** @format int32 */
  brand_id: number;
  country?: MarqCommonEnumsCountryCodeEnum[] | null;
  expiration_date?: MarqCommonModelOffsetDateTimeRange;
  ip_class?: string[] | null;
  is_expired_filter?: boolean | null;
  is_expiring_soon_filter?: boolean | null;
  keyword?: string | null;
  registered_date?: MarqCommonModelOffsetDateTimeRange;
}

export interface PortfolioTrademarkProtocolsUpdateTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  class_list: string[];
  countries: MarqCommonEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
  trademark_text?: string[] | null;
}

export interface RuleSmartRuleProtocolsCreateSmartRuleRequest {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  /** @format int32 */
  brand_id: number;
  channel: MarqCommonEnumsChannelTypeEnum;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  custom_tag_ids?: number[] | null;
  title: string;
}

export interface RuleSmartRuleProtocolsCreateSmartRuleResponse {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsDeleteSmartRuleRequest {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsGetAssetsRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetAssetsResponse {
  assets: RuleSmartRuleProtocolsGetAssetsResponseAsset[];
}

export interface RuleSmartRuleProtocolsGetAssetsResponseAsset {
  /** @format int32 */
  id: number;
  models: RuleSmartRuleProtocolsGetAssetsResponseAssetAtom[];
  name: string;
}

export interface RuleSmartRuleProtocolsGetAssetsResponseAssetAtom {
  /** @format int32 */
  id: number;
  image_url?: string | null;
  model_name: string;
  model_number?: string | null;
}

export interface RuleSmartRuleProtocolsGetCurrenciesResponse {
  currencies: MarqCommonEnumsCurrencyEnum[];
}

export interface RuleSmartRuleProtocolsGetCustomTagFiltersRequest {
  /** @format int32 */
  brand_id?: number | null;
  channel: MarqCommonEnumsChannelTypeEnum;
}

export interface RuleSmartRuleProtocolsGetCustomTagFiltersResponse {
  custom_tags: RuleSmartRuleProtocolsGetCustomTagFiltersResponseCustomTag[];
}

export interface RuleSmartRuleProtocolsGetCustomTagFiltersResponseCustomTag {
  /** @format int32 */
  id: number;
  name: string;
}

export interface RuleSmartRuleProtocolsGetDomainsRequest {
  channel: MarqCommonEnumsChannelTypeEnum;
}

export interface RuleSmartRuleProtocolsGetDomainsResponse {
  domain_countries: RuleSmartRuleProtocolsGetDomainsResponseDomainCountry[];
}

export interface RuleSmartRuleProtocolsGetDomainsResponseDomainCountry {
  country_code: MarqCommonEnumsCountryCodeEnum;
  country_name: string;
  domains: RuleSmartRuleProtocolsGetDomainsResponseDomainCountryDomain[];
}

export interface RuleSmartRuleProtocolsGetDomainsResponseDomainCountryDomain {
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  id: number;
  name: string;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponse {
  collections: RuleSmartRuleProtocolsGetInfringingImagesResponseCollection[];
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponseCollection {
  /** @format int32 */
  id?: number | null;
  images: RuleSmartRuleProtocolsGetInfringingImagesResponseCollectionInfringingImage[];
  name: string;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponseCollectionInfringingImage {
  /** @format int32 */
  id: number;
  image_url?: string | null;
}

export interface RuleSmartRuleProtocolsGetNumOfExpectedAffectedListingsRequest {
  /** @format int32 */
  brand_id: number;
  channel?: MarqCommonEnumsChannelTypeEnum;
  condition?: MarqCommonModelRuleSmartRuleConditionForClient;
  /** @format int32 */
  smart_rule_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetNumOfExpectedAffectedListingsResponse {
  /** @format int32 */
  count: number;
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsRequest {
  /** @format int32 */
  brand_id?: number | null;
  search?: string | null;
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsResponse {
  collections: RuleSmartRuleProtocolsGetOfficialImageCollectionsResponseCollection[];
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsResponseCollection {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  official_image_collection_id?: number | null;
  search?: string | null;
  search_after?: KotlinAny[] | null;
  /** @format int32 */
  size: number;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesResponse {
  images: RuleSmartRuleProtocolsGetOfficialImagesResponseOfficialImage[];
  search_after?: KotlinAny[] | null;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesResponseOfficialImage {
  /** @format int32 */
  id: number;
  image_url: string;
  name: string;
}

export interface RuleSmartRuleProtocolsGetSellersRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
}

export interface RuleSmartRuleProtocolsGetSellersResponse {
  seller_names: string[];
  /** @format int32 */
  total_count: number;
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusRequest {
  ids: number[];
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusResponse {
  smart_rules: RuleSmartRuleProtocolsGetSmartRuleStatusResponseSmartRuleIdWithStatus[];
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusResponseSmartRuleIdWithStatus {
  /** @format int32 */
  id: number;
  status: MarqCommonEnumsRuleSmartRuleStatusEnum;
}

export interface RuleSmartRuleProtocolsGetSmartRulesRequest {
  actions?: MarqCommonEnumsRuleSmartRuleActionEnum[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel: MarqCommonEnumsChannelTypeEnum;
  custom_tag_ids?: number[] | null;
  is_active?: boolean | null;
  sorted_by: MarqCommonEnumsSmartRuleSortedByEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface RuleSmartRuleProtocolsGetSmartRulesResponse {
  smart_rules: MarqBrandCoreModelRuleSmartRuleForClient[];
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleRequest {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  custom_tag_ids?: number[] | null;
  /** @format int32 */
  id: number;
  title: string;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleResponse {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleStatusRequest {
  /** @format int32 */
  id: number;
  to_active: boolean;
}

export interface SellerMarketplaceEnforcementActivityProtocolsExportExcelForEnforcementActivityRequest {
  seller_id: string;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsExportExcelForEnforcementActivityResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityCountRequest {
  seller_id: string;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  seller_id: string;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponse {
  listing_list: SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponseListingResponse[];
  seller_name: string;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponseListingResponse {
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  /** @format int32 */
  listing_id: number;
  listing_title?: string | null;
  listing_url?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  removed_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  reported_date?: string | null;
  status?: string | null;
  tag: MarqBrandCoreModelProtocolInvestigationTags;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetFilterOptionsRequest {
  seller_id: string;
}

export interface SellerSellerAnalyticClusterProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  cluster_id_list?: number[] | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticClusterProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticClusterProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterCountRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterCountResponse {
  /** @format int32 */
  total_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterListRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterListResponse {
  seller_cluster_list: MarqBrandModelResponseSellerBrandSellerClusterResponse[];
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponse {
  listing_list: SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponseListingResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  archived_date: string;
  asset_name: string;
  currency?: MarqCommonEnumsCurrencyEnum;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailDataDrivenProtocolsRequestDemandLetterRequest {
  /** @format int32 */
  cluster_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date: string;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailDataDrivenProtocolsRequestUDRPRequest {
  /** @format int32 */
  cluster_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date: string;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponse {
  listing_list: SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponseListingResponse {
  asset_name: string;
  currency?: MarqCommonEnumsCurrencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  detected_date: string;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponse {
  listing_list: SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponseListingResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  archived_date: string;
  asset_name: string;
  currency?: MarqCommonEnumsCurrencyEnum;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnEnforcementPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnEnforcementPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponse {
  listing_list: SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponseListingResponse {
  asset_name: string;
  currency?: MarqCommonEnumsCurrencyEnum;
  domain_name: string;
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  status: string;
  thumbnail_url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date: string;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoStatusRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsEditProfileRequest {
  address?: string | null;
  business_reg_num?: string | null;
  company_name?: string | null;
  country_code?: MarqCommonEnumsCountryCodeEnum;
  email?: string | null;
  legal_representative?: string | null;
  online_marketing_number?: string | null;
  phone?: string | null;
  seller_id: string;
  seller_name?: string | null;
  shop_name?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterProfileRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterProfileResponse {
  profile: MarqBrandCoreModelResponseClusterProfileResponse;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterSellerListRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  sort_by?: MarqCommonEnumsSellerintelSellerClusterDataSortByEnum;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterSellerListResponse {
  seller_list: MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData[];
}

export interface SellerSellerAnalyticDetailProtocolsGetDataDrivenInsightRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetDataDrivenInsightResponse {
  response: MarqBrandCoreModelResponseDataDrivenInsightResponse;
}

export interface SellerSellerAnalyticDetailProtocolsGetDetailRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetFirstEnforcementHistoryRequest {
  seller_id: string;
}

export interface SellerSellerAnalyticDetailProtocolsGetFirstEnforcementHistoryResponse {
  first_enforcement_history: MarqBrandCoreModelResponseSellerDetailResponseFirstEnforcementHistory[];
  /** @format int64 */
  reported_listings_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphRequest {
  /** @format int32 */
  cluster_id?: number | null;
  period_type: MarqCommonEnumsSellerListingStatusGraphTabType;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphResponse {
  detected: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
  enforcement_req: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
  removed: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData {
  label: string;
  /** @format int64 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsGetSummaryRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetSummaryResponse {
  summary: MarqBrandCoreModelResponseSellerDetailSummaryResponse;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_id_list?: string[] | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerCountRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerCountResponse {
  /** @format int32 */
  total_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date: string;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerListRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerListResponse {
  seller_list: MarqBrandModelResponseSellerSellerAnalyticsSellerInClusterResponse[];
}

export interface SellerSellerAnalyticSellerProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_id_list?: string[] | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticSellerProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerCountRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerListRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerListResponse {
  seller_list: MarqBrandModelResponseSellerSellerAnalyticsResponse[];
}

export interface SettingsBillingProtocolsAddDefaultCardRequest {
  token: string;
}

export interface SettingsBillingProtocolsGetBillingHistoryRequest {
  over_stripe_pi_id?: string | null;
}

export interface SettingsBillingProtocolsGetBillingHistoryResponse {
  has_more: boolean;
  history_list: SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRow[];
}

export interface SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRow {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  paid_success_data?: SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRowPaidSuccessData;
  payment_status: MarqCommonEnumsStripeBillingHistoryStatusEnum;
  stripe_pi_id: string;
  type: string;
}

export interface SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRowPaidSuccessData {
  /** @format double */
  amount_paid: number;
  invoice_pdf?: string | null;
}

export interface SettingsBillingProtocolsGetPaymentInfoResponse {
  payment_info?: SettingsBillingProtocolsGetPaymentInfoResponsePaymentInfo;
  plan_name: string;
  subscription_info?: SettingsBillingProtocolsGetPaymentInfoResponseSubscriptionInfo;
}

export interface SettingsBillingProtocolsGetPaymentInfoResponsePaymentInfo {
  brand: MarqCommonEnumsStripeStripeCardBrandEnum;
  declined: boolean;
  /** @format int32 */
  exp_month: number;
  /** @format int32 */
  exp_year: number;
  last4: string;
  name: string;
}

export interface SettingsBillingProtocolsGetPaymentInfoResponseSubscriptionInfo {
  /** @format double */
  billing_amount: number;
  billing_interval: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  next_billing_date?: string | null;
}

export interface SettingsBillingProtocolsUpdateDefaultCardRequest {
  token: string;
}

export interface SettingsBillingProtocolsUpdateDefaultCardResponse {
  failed_payment_processed: boolean;
}

export enum SettingsCreditsProtocolsGetCreditHistoryCreditHistoryType {
  RETURNED_CREDITS = 'RETURNED_CREDITS',
}

export interface SettingsCreditsProtocolsGetCreditHistoryRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  token?: string | null;
  type: SettingsCreditsProtocolsGetCreditHistoryCreditHistoryType;
}

export interface SettingsCreditsProtocolsGetCreditHistoryResponse {
  history: SettingsCreditsProtocolsGetCreditHistoryResponseHistory[];
  token: string;
}

export interface SettingsCreditsProtocolsGetCreditHistoryResponseHistory {
  /** @format int32 */
  accrued: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  type: string;
  /** @format int32 */
  used: number;
}

export interface SettingsCreditsProtocolsGetCreditsResponse {
  /** @format int32 */
  available_returned_credits: number;
}

export interface SettingsCustomTagProtocolsCreateCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  name: string;
}

export interface SettingsCustomTagProtocolsCreateCustomTagResponse {
  /** @format int32 */
  id: number;
}

export interface SettingsCustomTagProtocolsDeleteCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  /** @format int32 */
  id: number;
}

export interface SettingsCustomTagProtocolsGetCustomTagsRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
}

export interface SettingsCustomTagProtocolsGetCustomTagsResponse {
  custom_tags: SettingsCustomTagProtocolsGetCustomTagsResponseCustomTag[];
}

export interface SettingsCustomTagProtocolsGetCustomTagsResponseCustomTag {
  email: string;
  /** @format int32 */
  id: number;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface SettingsCustomTagProtocolsUpdateCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  /** @format int32 */
  id: number;
  name: string;
}

export interface AssetPiracyAssetPiracyProtocolsCreateAssetRequest {
  keywords?: string | null;
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
  thumbnail_url: string;
}

export enum PiracyCommonEnumsProductTypeEnum {
  Webcomic = 'webcomic',
  Video = 'video',
  Webnovel = 'webnovel',
  Game = 'game',
  Adult = 'adult',
  Sports = 'sports',
  Publishing = 'publishing',
  Music = 'music',
  Films = 'films',
  Animation = 'animation',
  ELearning = 'e-learning',
  Software = 'software',
}

export interface AssetPiracyAssetPiracyProtocolsGetPresignedUrlResponse {
  url: string;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetRequest {
  /** @format int32 */
  id: number;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetResponse {
  /** @format int32 */
  id: number;
  images: string[];
  keywords: string[];
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
}

export interface AssetPiracyAssetPiracyProtocolsDeleteAssetRequest {
  /** @format int32 */
  asset_id: number;
}

export interface AssetPiracyAssetPiracyProtocolsUpdateAssetRequest {
  /** @format int32 */
  id: number;
  keywords?: string | null;
  name: string;
  official_url: string;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export enum PiracyCommonEnumsCrCRStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
  NotAvailable = 'not_available',
}

export enum PiracyCommonEnumsCrCRTypeEnum {
  Enforce = 'enforce',
  Retract = 'retract',
  AddWhitelist = 'add_whitelist',
  ChangeAsset = 'change_asset',
}

export interface PiracyCommonModelAttachment {
  /** @format int32 */
  id?: number | null;
  name: string;
  s3_url: string;
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponse {
  cr_list: HomePiracyHomePiracyProtocolsGetCrListResponseCR[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponseCR {
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  client_cr_id: number;
  cr_status: PiracyCommonEnumsCrCRStatusEnum;
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  db_id: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  show_new_badge: boolean;
  urls: string[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListResponse {
  assets: AssetPiracyAssetPiracyProtocolsGetAssetListResponseAsset[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListResponseAsset {
  /** @format int32 */
  id: number;
  images: string[];
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  updated_date: string;
}

export interface AssetPiracyAssetPiracyProtocolsGetAllAssetListResponse {
  assets: AssetPiracyAssetPiracyProtocolsGetAllAssetListResponseAsset[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAllAssetListResponseAsset {
  /** @format int32 */
  id: number;
  name: string;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetChannelGroupCountResponse {
  /** @format int32 */
  channel_group_count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetSearchMethodFilterResponse {
  search_methods: PiracyCommonEnumsSearchMethodEnum[];
}

export enum PiracyCommonEnumsSearchMethodEnum {
  Web = 'web',
  Image = 'image',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
  Douyin = 'Douyin',
  Youtube = 'Youtube',
  YoutubeShorts = 'Youtube Shorts',
  VK = 'VK',
  Dailymotion = 'Dailymotion',
  Vimeo = 'Vimeo',
  Twitch = 'Twitch',
  Bilibili = 'Bilibili',
  BilibiliTV = 'Bilibili TV',
  GooglePlay = 'Google Play',
  AppleAppstore = 'Apple Appstore',
  Telegram = 'Telegram',
  Discord = 'Discord',
  Reddit = 'Reddit',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export enum PiracyCommonEnumsClientStatus {
  Detected = 'detected',
  Confirmed = 'confirmed',
  Reported = 'reported',
  Enforced = 'enforced',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  filter_search?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterResponse {
  /** @format int32 */
  total_count: number;
  websites: PiracyCommonModelIdNameCount[];
}

export interface PiracyCommonModelIdNameCount {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsExportCsvRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  listing_id_list?: number[] | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export enum PiracyCommonEnumsSortColumnEnum {
  AssetName = 'asset_name',
  AssetType = 'asset_type',
  UpdatedDate = 'updated_date',
  SearchMethod = 'search_method',
  CreatedDate = 'created_date',
  DetectedDate = 'detected_date',
  Domain = 'domain',
  Views = 'views',
  Subscriptions = 'subscriptions',
  RelevancyScore = 'relevancy_score',
  InfringingScore = 'infringing_score',
}

export enum PiracyCommonEnumsSortOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetEnforcementHistoriesRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  listing_id: number;
}

export enum PiracyCommonEnumsChannelEnum {
  Google = 'Google',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
  Douyin = 'Douyin',
  Youtube = 'Youtube',
  VK = 'VK',
  Dailymotion = 'Dailymotion',
  Vimeo = 'Vimeo',
  Twitch = 'Twitch',
  Bilibili = 'Bilibili',
  BilibiliTV = 'Bilibili TV',
  GooglePlay = 'Google Play',
  AppleAppstore = 'Apple Appstore',
  Telegram = 'Telegram',
  Discord = 'Discord',
  Reddit = 'Reddit',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetEnforcementHistoriesResponse {
  enforcement_histories?:
    | MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetEnforcementHistoriesResponseEnforcementHistory[]
    | null;
  last_status?: string | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetEnforcementHistoriesResponseEnforcementHistory {
  /**
   * @format date
   * @example "2023-03-01"
   */
  created_date: string;
  /** @format int32 */
  report_id: number;
  report_status: PiracyCommonEnumsLReportStatusEnum;
}

export enum PiracyCommonEnumsLReportStatusEnum {
  DataNeeded = 'data_needed',
  BuildingData = 'building_data',
  BuildingDataFailed = 'building_data_failed',
  Ready = 'ready',
  Reporting = 'reporting',
  Done = 'done',
  ReportBuildFailed = 'report_build_failed',
  ReportFailed = 'report_failed',
  Unneeded = 'unneeded',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponse {
  list: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponseListing[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponseListing {
  asset_name: string;
  channel: PiracyCommonEnumsChannelEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_name: string;
  features: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures;
  /** @format int32 */
  id: number;
  search_keyword_list: string[];
  search_type: PiracyCommonEnumsSearchMethodEnum;
  title: string;
  url: string;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures {
  top_search: boolean;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyWebsiteContentsDetailPiracyResponse {
  detail_info: MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse;
  enforcement_progress: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse {
  asset_name: string;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_name: string;
  features: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures;
  image_list: string[];
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  profile_name?: string | null;
  search_keyword_list: string[];
  search_method: PiracyCommonEnumsSearchMethodEnum;
  snapshot_url?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date?: string | null;
  /** @format int32 */
  views?: number | null;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse {
  google_progress?: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem[];
  status?: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem {
  /** @format int32 */
  history_id: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export enum PiracyCommonEnumsWebsiteListingHistoryStatusEnum {
  ReportedToGoogle = 'reported_to_google',
  Delisted = 'delisted',
  Denied = 'denied',
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetImagesResponse {
  images: string[];
}

export interface PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineResponse {
  chart_value_list: PiracyCommonModelListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PiracyCommonModelListingsChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  grouped_count_list?: PiracyCommonModelListingsChartValueGroupedCount[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format int64 */
  top_search_count?: number | null;
}

export interface PiracyCommonModelListingsChartValueGroupedCount {
  /** @format int64 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaResponse {
  chart_value_list: PiracyCommonModelListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PerfPiracyPerformancePiracyProtocolsGetOffenderDataRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetOffenderDataResponse {
  /** @format int64 */
  repeat_offender_count: number;
  /** @format int32 */
  repeat_offender_percent: number;
  /** @format int64 */
  total_offender_count: number;
}

export interface PerfPiracyPerformancePiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  enforced_percent: number;
}

export interface PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsResponse {
  rate_list: PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsResponseRate[];
}

export interface PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsResponseRate {
  channel_name: string;
  /** @format double */
  percent: number;
}

export interface PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsResponse {
  top_domains: PiracyCommonModelTopOffender[];
}

export interface PiracyCommonModelTopOffender {
  channel_name: string;
  /** @format int32 */
  id: number;
  name: string;
  /** @format int64 */
  removed_count: number;
}

export interface PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesResponse {
  top_profiles: PiracyCommonModelTopOffender[];
}

export interface PerfPiracyPerformancePiracyProtocolsReportGetListRequest {
  sort_order: PiracyCommonEnumsSortOrderEnum;
}

export interface PerfPiracyPerformancePiracyProtocolsReportGetListResponse {
  list: PerfPiracyPerformancePiracyProtocolsReportGetListResponseReport[];
}

export interface PerfPiracyPerformancePiracyProtocolsReportGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  is_new: boolean;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  enforced_percent: number;
  /** @format double */
  one_month_percent: number;
  /** @format double */
  one_week_percent: number;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateOverTimeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export enum PiracyCommonEnumsPerfPerfTimeFrequencyEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateOverTimeResponse {
  chart_value_list: PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue[];
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PiracyCommonModelCodeLabelComboBoxResponse {
  label: string;
  value: string;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateTopDataRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateTopDataResponse {
  top_data_list: PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateTopDataResponseTopData[];
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateTopDataResponseTopData {
  channel_name: string;
  /** @format double */
  rate_percent: number;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateTopCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsCompRatePiracyProtocolsGetComplianceRateOverTimeCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export enum PiracyCommonEnumsPerfPerfListingStatusEnum {
  Detected = 'detected',
  Reported = 'reported',
  Removed = 'removed',
}

export enum PiracyCommonEnumsPerfPerfChannelGroupEnum {
  SearchEngine = 'search_engine',
  SocialMedia = 'social_media',
}

export enum PiracyCommonEnumsPerfPerfGroupByEnum {
  None = 'none',
  Asset = 'asset',
  Domain = 'domain',
  Channel = 'channel',
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeResponse {
  chart_value_list: PiracyCommonModelListingsChartValue[];
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  total_count: number;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeRequest {
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeResponse {
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataResponse {
  top_data_list: PiracyCommonModelTopData[];
}

export interface PiracyCommonModelTopData {
  grouped_list?: PiracyCommonModelTopDataGroupedTopData[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format double */
  listing_percent: number;
  name: string;
}

export interface PiracyCommonModelTopDataGroupedTopData {
  /** @format int64 */
  count: number;
  /** @format int32 */
  group_id?: number | null;
  group_label: string;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataResponse {
  top_data_list: PiracyCommonModelTopData[];
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataResponse {
  top_data_list: PiracyCommonModelTopData[];
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  channel_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersResponse {
  /** @format int64 */
  repeat_offender_count: number;
  /** @format int64 */
  total_offender_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesRequest {
  channel_filter: PiracyCommonEnumsChannelEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponse {
  profile_list: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponseTopInfringingProfile[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponseTopInfringingProfile {
  channel_name: string;
  /** @format int32 */
  id: number;
  profile_name: string;
  /** @format int64 */
  removed_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponse {
  domain_list: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponseTopInfringingDomain[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponseTopInfringingDomain {
  domain_name: string;
  /** @format int32 */
  id: number;
  /** @format int64 */
  removed_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListResponse {
  channel_filter: PiracyCommonModelCodeLabelComboBoxResponse[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesCsvRequest {
  channel_filter: PiracyCommonEnumsChannelEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PiracyCommonProtocolFileResponse {
  /** @format byte */
  bytes: string;
  content_type: IoKtorHttpContentType;
  filename: string;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetChannelGroupCountResponse {
  /** @format int32 */
  channel_group_count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetSearchMethodFilterResponse {
  search_methods: PiracyCommonEnumsSearchMethodEnum[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  filter_search?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListResponse {
  listing_id_list: number[];
  /** @format int32 */
  size: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyWebsiteContentsDetailPiracyResponse {
  detail_info: MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse;
  enforcement_progress: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse {
  asset_name: string;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_name: string;
  features: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures;
  image_list: string[];
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  profile_name?: string | null;
  search_keyword_list: string[];
  search_method: PiracyCommonEnumsSearchMethodEnum;
  snapshot_url?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date?: string | null;
  /** @format int32 */
  views?: number | null;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse {
  google_progress?: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem[];
  status?: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem {
  /** @format int32 */
  history_id: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetChannelGroupCountResponse {
  /** @format int32 */
  channel_group_count: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetSearchMethodFilterResponse {
  search_methods: PiracyCommonEnumsSearchMethodEnum[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetWebsiteFilterRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  filter_search?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsExportCsvRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  listing_id_list?: number[] | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponse {
  list: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponseListing[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponseListing {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
  asset_name: string;
  platform_name: string;
  profile_name: string;
  search_method: PiracyCommonEnumsSearchMethodEnum;
  thumbnail_url: string;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  update_date: string;
  url: string;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListResponse {
  listing_id_list: number[];
  /** @format int32 */
  size: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse {
  detail_info: MarqBrandModelResponseMonitoringSocialmediaPiracyDetailInfoResponse;
  enforcement_progress: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse;
}

export interface MarqBrandModelResponseMonitoringSocialmediaPiracyDetailInfoResponse {
  asset_name: string;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  image_list: string[];
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  platform_name: string;
  profile_name?: string | null;
  search_keyword_list: string[];
  search_method: PiracyCommonEnumsSearchMethodEnum;
  snapshot_url?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date?: string | null;
  /** @format int32 */
  views?: number | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequest {
  doc_list?: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequestFileRequest[] | null;
  listing_id_list: number[];
  note?: string | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequestFileRequest {
  file_name: string;
  url: string;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListRequest {
  cr_status_list: PiracyCommonEnumsCrCRStatusEnum[];
  cr_type?: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponse {
  cr_list: HomePiracyHomePiracyProtocolsGetCrListResponseCR[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponseCR {
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  client_cr_id: number;
  cr_status: PiracyCommonEnumsCrCRStatusEnum;
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  db_id: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  show_new_badge: boolean;
  urls: string[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListCountRequest {
  cr_status_list: PiracyCommonEnumsCrCRStatusEnum[];
  cr_type?: PiracyCommonEnumsCrCRTypeEnum;
}

export interface HomePiracyHomePiracyProtocolsGetCrListCountResponse {
  /** @format int32 */
  cr_count: number;
}

export interface HomePiracyHomePiracyProtocolsGetCrDetailsRequest {
  /** @format int32 */
  db_id: number;
}

export interface HomePiracyHomePiracyProtocolsGetCrDetailsResponse {
  admin_attachments: PiracyCommonModelAttachment[];
  admin_response?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  admin_updated_date?: string | null;
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  client_cr_id: number;
  cr_status: PiracyCommonEnumsCrCRStatusEnum;
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  db_id: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  urls: string[];
}

export interface HomePiracyHomePiracyProtocolsAddNewRequestRequest {
  attachments: PiracyCommonModelAttachment[];
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  details: string;
  urls?: string[] | null;
}

export interface HomePiracyHomePiracyProtocolsGetUploadUrlRequest {
  file_name: string;
}

export interface HomePiracyHomePiracyProtocolsGetUploadUrlResponse {
  url: string;
}

export interface HomePiracyHomePiracyProtocolsGetCrHasNewBadgeResponse {
  cr_has_new: boolean;
}

export interface HomePiracyHomePiracyProtocolsReportGetListResponse {
  list: HomePiracyHomePiracyProtocolsReportGetListResponseReport[];
}

export interface HomePiracyHomePiracyProtocolsReportGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  is_new: boolean;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}
